/* Auto-generated by vite-plugin-messages. */
/* Do not edit this file directly. Update the JSON source files instead. */
/* Source of truth: resources/assets/js/lang */
/* Language: sv */

export const messages = {
  // Source: resources/assets/js/lang/ui/sv.json
  "ui": {
    "dialogOk": "Ok",
    "dialogCancel": "Avbryt",
    "close": "Stäng",
    "loading": "Laddar",
    "monday": "måndag",
    "tuesday": "tisdag",
    "wednesday": "onsdag",
    "thursday": "torsdag",
    "friday": "fredag",
    "saturday": "lördag",
    "sunday": "söndag",
    "mondayDefinite": "måndagen",
    "tuesdayDefinite": "tisdagen",
    "wednesdayDefinite": "onsdagen",
    "thursdayDefinite": "torsdagen",
    "fridayDefinite": "fredagen",
    "saturdayDefinite": "lördagen",
    "sundayDefinite": "söndagen",
    "datePickerSave": "Spara",
    "datePickerReset": "Nollställ",
    "datePickerChooseTime": "Välj tid (:timezone)",
    "importCompletedNotificationTitle": "Importen färdig",
    "importCompletedNotificationContent": "Kontakterna har importerats till din adressbok.",
    "deleteTeamSuccessTitle": "Team borttaget",
    "deleteTeamSuccessMessage": "Teamet :name har tagits bort.",
    "deleteTeamFailedTitle": "Kunde inte ta bort teamet",
    "deleteTeamFailedMessage": "Teamet :name kunde inte tas bort.",
    "required": "Obligatoriskt",
    "placeholderLink": "Länk",
    "linkTypeWebsite": "Webbsajt (http://)",
    "linkTypeWebsiteS": "Webbsajt (https://)",
    "linkTypeEmail": "E-post (mailto:)",
    "linkTypeSms": "SMS (sms:)",
    "linkTypePhone": "Telefon (tel:)",
    "linkTypeAnchor": "Hoppa till sektion",
    "linkTypeSkype": "Skype (skype:)",
    "linkTypeFacetime": "Facetime (facetime:)",
    "linkTypeSpotify": "Spotify (spotify:)",
    "noAnchors": "Ge dina sektioner ett namn för att kunna länka till dem.",
    "placeholderAnchor": "Välj sektion",
    "linkEditorTitle": "Redigera länk",
    "linkEditorSave": "Spara",
    "linkEditorCancel": "Avbryt",
    "linkEditorUnlink": "Ta bort länk",
    "buttonUnlink": "Ta bort länk",
    "chooseImage": "Välj bild",
    "noLinkError": "Du måste ange en länk",
    "linkEditorTitleInputLabel": "Länktitel",
    "linkEditorTitlePlaceholder": "Beskriv länken",
    "linkEditorTitleHelp": "Lägg till en frivillig länkbeskrivning",
    "typeaheadLimitReached": "Du kan bara välja :limit e-postadresser",
    "searchPlaceholder": "Sök...",
    "toolbarFormatting": "Formateringsalternativ",
    "toolbarMoreOptions": "Fler formateringsalternativ",
    "toolbarImprove": "Förbättra",
    "toolbarImproveAriaLabel": "Förbättra text med AI",
    "toolbarInsert": "Infoga",
    "toolbarInsertMergeTag": "Infoga personlig tagg",
    "toolbarTextAlignment": "Textjustering",
    "toolbarAlignLeft": "Vänsterjusterad",
    "toolbarAlignCenter": "Centrerad",
    "toolbarAlignRight": "Högerjusterad",
    "toolbarAlignJustify": "Marginaljusterad",
    "toolbarTextFormatting": "Textformatering",
    "toolbarBold": "Fet",
    "toolbarItalic": "Kursiv",
    "toolbarStrikethrough": "Genomstruken",
    "toolbarUnderline": "Understruken",
    "toolbarTextList": "Textlista",
    "toolbarUnorderedList": "Punktlista",
    "toolbarOrderedList": "Numrerad lista",
    "toolbarFontStyle": "Teckenstil",
    "toolbarFontSize": "Teckenstorlek",
    "toolbarLineHeight": "Radhöjd",
    "toolbarLetterSpacing": "Teckenavstånd",
    "toolbarOptionAuto": "Auto",
    "fontWeightThin": "Tunn",
    "fontWeightExtraLight": "Extra ljus",
    "fontWeightLight": "Ljus",
    "fontWeightNormal": "Normal",
    "fontWeightMedium": "Medium",
    "fontWeightSemiBold": "Halvfet",
    "fontWeightBold": "Fet",
    "fontWeightExtraBold": "Extra fet",
    "fontWeightBlack": "Svart",
    "fontWeightThinItalic": "Tunn kursiv",
    "fontWeightExtraLightItalic": "Extra ljus kursiv",
    "fontWeightLightItalic": "Ljus kursiv",
    "fontWeightNormalItalic": "Normal kursiv",
    "fontWeightMediumItalic": "Medium kursiv",
    "fontWeightSemiBoldItalic": "Halvfet kursiv",
    "fontWeightBoldItalic": "Fet kursiv",
    "fontWeightExtraBoldItalic": "Extra fet kursiv",
    "fontWeightBlackItalic": "Svart kursiv",
    "errorRequestTooLarge": "Filen är för stor för att laddas upp. Välj en mindre fil.",
    "errorServer": "Något gick fel. Försök igen om en stund.",
    "errorNetwork": "Okänt fel. Kontrollera din anslutning och försök igen.",
    "errorTooManyAttempts": "För många försök. Vänta några minuter och försök igen.",
    "imageLoadFailed": "Bilden kunde inte laddas",
  },
  "pages": {
    "write": {
      // Source: resources/assets/js/lang/pages/write/layout/sv.json
      "layout": {
        "pageTitle": "Redigera",
        "or": "eller",
        "buttonDelete": "Radera",
        "buttonDuplicatedraft": "Duplicera utkast",
        "buttonSaveastemplate": "Spara som mall",
        "saveAsTemplateTitle": "Spara som mall",
        "saveAsTemplateDescription": "Spara den här designen som en återanvändbar mall.",
        "saveAsTemplatePlaceholder": "Döp din mall",
        "savedAsTemplateNotificationTitle": "Mallen sparad",
        "savedAsTemplateNotificationContent": "Du sparade en ny mall",
        "savedAsTemplateNotificationFailedTitle": "Misslyckades med att spara mall",
        "savedAsTemplateNotificationFailedContent": "Av någon anledning gick det inte att spara din mall",
        "buttonSaveAsTemplate": "Spara",
        "changesSaved": "Ändringar sparade",
        "noChanges": "Inga ändringar",
        "savingChanges": "Sparar ändringar...",
        "changesMade": "Osparade ändringar",
        "errorSaving": "Fel vid sparande",
        "buttonClose": "Stäng",
        "buttonTestandsend": "Testa & skicka",
        "buttonTestandSchedule": "Testa & schemalägg",
        "buttonCancelSchedule": "Avbryt schemaläggning",
        "buttonTest": "Förhandsvisa",
        "fieldTemplateName": "Namn på mall",
        "hintTemplateName": "En kort malltitel",
        "buttonDeleteTemplate": "Ta bort mall",
        "buttonDuplicateTemplate": "Duplicera mall",
        "buttonCreateEmails": "Ny från mall",
        "fieldFrom": "Från",
        "fieldTo": "Till",
        "placeholderTo": "Välj mottagare",
        "chooseTitle": "Välj mottagare",
        "fieldWhen": "När",
        "placeholderWhen": "Skickas direkt",
        "whenNow": "Nu",
        "hintWhen": "Skicka direkt eller schemalägg",
        "fieldSubject": "Ämne",
        "placeholderSubject": "Håll dig kort och trevlig",
        "buttonSuggestsubject": "Föreslå ämne",
        "titleDelete": "Vill du ta bort det här utkastet?",
        "descriptionDelete": "Om du tar bort utkastet kan du inte ångra dig. Om du vill skapa ett nytt mejl men behålla utkastet stäng bara det här mejlet.",
        "buttonCancel": "Avbryt",
        "buttonEditcontacts": "Redigera kontakter",
        "buttonChoose": "Välj :contacts kontakter",
        "chooseList": "Välj en lista",
        "newSegment": "Nytt segment",
        "displayContacts": "Välj {0} kontakt|Välj {0} kontakter",
        "sendingTo": "Skickar till {0} kontakt|Skickar till {0} kontakter",
        "sendingToShort": "{0} kontakt|{0} kontakter",
        "contactSingular": "kontakt",
        "contactPlural": "kontakter",
        "filterLabel": "Filter",
        "sendToLabel": "Skicka till",
        "sendToEveryone": "Alla",
        "sendToOpened": "Som öppnade",
        "sendToDidntOpen": "Som inte öppnade",
        "sendToClicked": "Som klickade",
        "sendToDidntClick": "Som inte klickade",
        "sendToOpenedOrClicked": "Som öppnade eller klickade",
        "sendToDidntOpenOrClick": "Som inte öppnade eller klickade",
        "sendToEmail": "Välj utskick",
        "uniqueNotSuppressed": "Unika och ej undantagna",
        "noContacts": "Inga kontakter matchar ditt urval",
        "errorNoAccessMessage": "Detta utkast redigeras av :name. För att göra ändringar måste du ta över redigeringen. Det kommer att låsa ute den nuvarande redigeraren med möjlig dataförlust.",
        "errorNoAccessTitle": "Utkastet är låst",
        "buttonTakeover": "Ta över",
        "buttonLeave": "Lämna",
        "buttonWatch": "Visa",
        "takeoverRequestTitle": "Begäran om övertagande",
        "takeoverRequestDescription": ":name vill ta över redigeringen. Låset överförs automatiskt om :seconds sekunder.",
        "takeoverAccept": "Lämna över",
        "takeoverKeepEditing": "Fortsätt redigera",
        "takeoverWaitingTitle": "Begär åtkomst",
        "takeoverWaitingDescription": "Väntar på svar från :name...",
        "takeoverRejectedTitle": "Begäran nekad",
        "takeoverRejectedDescription": ":name nekade din begäran om övertagande.",
        "editorIsEditing": ":name redigerar",
        "errorNoSubject": "Du måste fylla i en ämnesrad.",
        "errorLoadTitle": "Kunde inte ladda mailet",
        "errorLoadDescription": "Något gick fel vid laddning av detta mail. Det kan ha raderats eller så saknar du behörighet.",
        "menuEdit": "Redigera",
        "menuDelete": "Radera",
        "chooseRecipients": "Välj mottagare",
      },
    },
    // Source: resources/assets/js/lang/pages/template/sv.json
    "template": {
      "pageTitle": "Mall",
    },
    // Source: resources/assets/js/lang/pages/team-selection/sv.json
    "team-selection": {
      "useMinutemailerAs": "Välj team",
      "yourPersonalAccount": "Ditt personliga konto",
      "nrPeople": "1 team-medlem|{0} team-medlemmar",
      "cantFindYourTeam": "Kan du inte hitta ditt team?",
      "loginToAnotherAccount": "Logga in på ett annat konto",
    },
    // Source: resources/assets/js/lang/pages/suppressions/sv.json
    "suppressions": {
      "title": "Undantagslista",
      "description": "Om vi upptäcker en hård studs eller ett klagomål för en e-postadress läggs den till undantagslistan och vi kommer inte skicka mejl till den kontakten från den domänen igen. Varje domän har en egen undantagslista. Om du har löst problemet som orsakade studsen kan du ta bort e-postadressen från undantagslistan och försöka igen.",
      "placeholderSearch": "Sök...",
      "showing": "Visar :count undantagen adress|Visar :count undantagna adresser",
      "noDomains": "Du kan endast se undantagna adresser för autentiserade domäner.",
      "noDomainsAction": "Autentisera domän",
      "noSuppressions": "Du har inga undantag för den här domänen.",
      "noSuppressionsFound": "Inga undantag hittades",
      "tableHeadEmail": "E-postadress",
      "tableHeadType": "Typ",
      "tableHeadError": "Felmeddelande",
      "tableHeadWhen": "När",
      "deleteConfirmTitle": "Vill du ta bort undantaget?",
      "deleteConfirmBody": "Om du har löst problemet med e-postadressen kan du ta bort den från undantagslistan och försöka igen.",
      "deleteConfirmButton": "Ta bort undantag",
      "export": "Ladda ned",
      "allDomains": "Alla domäner",
      "typeBounce": "Studs",
      "typeComplaint": "Klagomål",
      "typeUnsubscribe": "Avregistrerad",
      "removeFromSuppression": "Ta bort från undantagslistan",
      "delete": "Ta bort kontakt",
      "deleteSuccess": "Undantag borttaget",
    },
    "settings": {
      // Source: resources/assets/js/lang/pages/settings/teams/sv.json
      "teams": {
        "pageTitle": "Team",
        "description": "Det här är de team du tillhör. Du kan skapa så många team du vill. Du har alltid ett privat team där du inte kan bjuda in team-medlemmar men som kan användas för att gå med i andra team. Det privata teamet kan inte tas bort.",
        "teamsReadMore": "Läs mer om teams",
        "teamsReadMoreurl": "https://www.minutemailer.com/sv/teams",
        "createTeam": "Skapa team",
        "activeTeam": "Aktivt team",
        "teamPeople": "{0} medlem|{0} medlemmar",
        "role": "Du är :role",
        "yourPrivateTeam": "Ditt privata team",
        "switchToTeam": "Byt till team",
        "leaveTeam": "Lämna team",
        "deleteTeam": "Ta bort team",
        "createTeamTitle": "Skapa ett team",
        "teamName": "Namn på team",
        "businessName": "Namn på företag eller organisation",
        "email": "Teamets e-postadress",
        "address": "Adress",
        "city": "Stad",
        "state": "Kommun",
        "postalCode": "Postnummer",
        "website": "Hemsidesadress",
        "teamCreatedNotificationTitle": "Team skapat",
        "teamCreatedNotificationMessage": "Team :name har skapats.",
        "confirmLeaveTeam": "Du kommer inte längre ha tillgång till utkast, mallar eller kontakter som tillhör det här teamet.",
        "confirmLeaveTitle": "Lämna team?",
        "confirmLeaveButton": "Lämna team",
        "buttonCancel": "Avbryt",
        "failedToLeaveTeamTitle": "Misslyckades med att lämna team",
        "failedToLeaveTeamContent": "Vi kunde inte ta bort dig från teamet.",
        "createTeamDescription": "Skapa ett team för ditt företag, ett projekt, din hobby eller en förening du är engagerad i.",
        "noTeamsFound": "Inga team hittades",
      },
      // Source: resources/assets/js/lang/pages/settings/people/sv.json
      "people": {
        "pageTitle": "Medlemmar",
        "description": "Bjud in medlemmar till ditt team och tilldela roller. Du kan också ta bort medlemmar från teamet om du är admin. Varje medlem du bjuder in som godkänner inbjudan ger ditt team 1 000 gratis krediter.",
        "peopleReadMore": "Läs mer om teams och team-medlemmar",
        "peopleReadMoreurl": "https://www.minutemailer.com/sv/teams",
        "invite": "Bjud in",
        "cancelInvite": "Avbryt inbjudan",
        "removeFromTeam": "Ta bort från team",
        "removedFromTeamTitle": "Medlem borttagen",
        "removedFromTeamContent": "Vi tog bort en medlem från ditt team.",
        "roleChangedTitle": "Rollen uppdaterad",
        "roleChangedContent": "Rollen för medlemmen har uppdaterats.",
        "roleChangeErrorTitle": "Kunde inte uppdatera rollen",
        "roleChangeErrorContent": "Vi kunde inte uppdatera rollen för medlemmen.",
        "invitationResentTitle": "Inbjudan skickad",
        "invitationResentContent": "Be personen att kolla deras e-post och skräpkorg efter inbjudan.",
        "resendInvite": "Skicka om inbjudan",
        "fetchError": "Kunde inte ladda teammedlemmar",
        "retryFetch": "Försök igen",
        "invitationResendError": "Vi kunde inte skicka om inbjudan. Försök igen.",
        "invitationCancelError": "Vi kunde inte avbryta inbjudan. Försök igen.",
      },
      // Source: resources/assets/js/lang/pages/settings/layout/sv.json
      "layout": {
        "menuDesign": "Design",
        "menuAccount": "Konto",
        "menuEmail": "E-post",
        "menuBilling": "Betalning",
        "menuAPI": "API",
        "menuFields": "Fält",
        "menuTeams": "Teams",
        "menuPeople": "Medlemmar",
        "errorConnection": "Vi tappade din internetanslutning. Försöker ansluta igen...",
        "newVersion": "Vi har uppdaterat Minutemailer med en ny och förbättrad version. Ladda om för att uppdatera.",
        "buttonUpdate": "Uppdatera",
        "menuHome": "Hem",
        "menuContacts": "Kontakter",
        "menuResult": "Resultat",
        "menuContent": "Innehåll",
        "pausedAccount": "Ditt konto har inaktiverats på grund av aktiviteter som bryter mot våra användarvillkor. Kontakta vår support för att återaktivera det.",
        "contactSupport": "Kontakta support",
        "menuSettings": "Inställningar",
      },
      // Source: resources/assets/js/lang/pages/settings/fields/sv.json
      "fields": {
        "public": "Synligt",
        "hidden": "Gömt",
        "pageTitle": "Kontaktfält",
        "description": "Dessa fält används för dina kontakter. Lägg till fält för att spara mer information om dina kontakter. Om du tar bort ett fält försvinner all data för det fältet för alla dina kontakter.",
        "createField": "Nytt fält",
        "fieldName": "Namn på fält",
        "tableName": "Fältnamn",
        "tableType": "Typ av fält",
        "tableVisibility": "Synlighet",
        "tableMergeTag": "Smart tagg",
        "save": "Spara",
        "remove": "Ta bort",
        "cancel": "Avbryt",
        "fieldDeleted": "Fält raderat",
        "fieldDeleteddesc": "Se till att ta bort det borttagna fältets smarta tagg i dina utkast, om du använt det.",
        "fieldErrortitle": "Något gick fel",
        "fieldErrordesc": "Kunde inte ta bort fältet. Pröva igen.",
        "noFieldsFound": "Inga fält hittades",
      },
      // Source: resources/assets/js/lang/pages/settings/email/sv.json
      "email": {
        "pageTitle": "E-postinställningar",
        "emailAccountEmailTitle": "Din e-postadress",
        "emailAccountEmailDescription": "Ditt kontos e-postadress som används för att logga in på Minutemailer och också är den förvalda e-postadress du skickar mejl från. Vill du lägga till fler e-postadresser att skicka ifrån kan du göra det under ditt teams e-postinställningar.",
        "emailFromAddressesTitle": "Avsändaradresser",
        "emailFromAddressesDescription": "Lägg till e-postadresser att skicka från. Du behöver verifiera varje e-postadress och autentisera domänen innan du kan skicka från den.",
        "emailAddAddress": "Lägg till e-postadress",
        "emailAddressVerified": "Verifierad",
        "emailAddressNeedsVerify": "Behöver verifieras",
        "emailDomainsTitle": "Autentisera e-postdomäner",
        "emailDomainsDescription": "Du behöver autentisera din e-postdomän genom att lägga till DNS-poster. Detta krävs för att kunna skicka från din egen domän.",
        "emailDomainsLink": "Följ guiden för att komma igång",
        "emailDomainsLinkurl": "https://www.minutemailer.com/sv/guides/authenticate/",
        "emailDomainsNotAuthenticated": "Ej autentiserad",
        "emailDomainsAuthenticated": "Autentiserad",
        "emailDomainsAuthenticateButton": "Autentisera",
        "addedEmailNotificationTitle": "Bekräfta e-post",
        "addedEmailNotificationContent": "Kolla i din inkorg för att bekräfta din e-postadress (:email)",
        "authenticateTitle": "Autentisera din domän",
        "authenticateText": "Autentisera din domän :domain genom att uppdatera dina DNS inställningar. Du kan behöva vänta upp till 12 timmar för att ändringarna ska slå igenom helt. Följ gärna vår",
        "authenticateLink": "guide för DKIM och SPF autentisering",
        "buttonShowsettings": "Visa inställningar",
        "buttonValidate": "Validera",
        "buttonAuthenticate": "Autentisera",
        "buttonCancel": "Avbryt",
        "buttonSave": "Spara",
        "titleAuthenticate": "Autentisera din domän",
        "textAuthenticate": "Autentisera domänen :domain genom att ändra din domäns DNS inställningar. Efter att ändringarna har gjorts kan du behöver vänta upp till 12 timmar för att ändringarna ska slå igenom.",
        "linkDomainauthentication": "domänautentisering",
        "placeholderEmail": "Skriv e-postadress",
        "placeholderName": "Skriv namn",
        "tableStatus": "Status",
        "tableEmail": "E-post",
        "tableName": "Namn",
        "menuEdit": "Redigera",
        "menuDelete": "Ta bort",
        "menuResend": "Skicka om länk",
        "removeTitle": "Ta bort e-postadressen?",
        "removeText": "Detta kommer ta bort e-postadressen från ditt konto.",
        "removeButton": "Ta bort",
        "readyToSend": "Redo att användas",
        "emailreadyTitle": "Färdig e-postadress från Minutemailer",
        "emailreadyDescription": "Använd e-postadressen för att skicka nyhetsbrev från. Om du vill skicka från din egen e-postadress behöver du lägga till den nedan och autentisera domänen.",
        "emailreadyNamePlaceholder": "Företag eller team-namn",
        "emailreadyPlaceholder": "Företag eller team-namn",
        "save": "Spara ändringar",
        "emailreadyLabel": "E-postadress",
        "emailreadyNameLabel": "Avsändarnamn",
        "replyToEmailText": "Svar på mejl går till teamets e-postadress: :email",
        "editTeamEmail": "Redigera teamets e-postadress",
        "accountEmail": "Kontots e-post",
        "accountEmailEdit": "Redigera",
      },
      // Source: resources/assets/js/lang/pages/settings/design/sv.json
      "design": {
        "title": "Designinställningar",
        "pageTitle": "Designinställningar",
        "description": "Ställ in din design så att dina nyhetsbrev följer din grafiska profil.",
        "logotypeTitle": "Din logotyp",
        "logotypeDescription": "Ladda upp din logotyp som en PNG, GIF eller JPG.",
        "bodyTitle": "Innehåll",
        "bodyDescription": "Ställ in design för innehållet i dina nyhetsbrev.",
        "buttonTitle": "Knappar",
        "buttonDescription": "Ställ in design för dina knappar.",
        "bodyFontLabel": "Typsnitt",
        "dividerTitle": "Avdelare",
        "dividerDescription": "Ställ in design för dina avdelare.",
        "dividerColorLabel": "Färg",
        "dividerStyleLabel": "Stil",
        "dividerThicknessLabel": "Tjocklek",
        "dividerWidthLabel": "Bredd",
        "colorsTitle": "Färger",
        "brandColorHelp": "Färg på varumärke",
        "buttonColorHelp": "Färg på knappar",
        "linkColorHelp": "Länkfärg",
        "backgroundColorHelp": "Bakgrundsfärg",
        "typefaceTitle": "Typsnitt",
        "typefaceSelect": "Välj typsnitt",
        "typefaceMain": "Huvudtypsnitt",
        "typefaceMainhelp": "Välj ditt varumärkes typsnitt eller det som liknar det mest. Webbsäkra typsnitt fungerar i alla e-postklienter.",
        "typefaceButton": "Typsnitt för knappar",
        "typefaceButtonhelp": "Om du vill kan du välja ett kompletterande typsnitt för knappar.",
        "headerTitle": "Sidhuvud",
        "viewinBrowserHelp": "Text för visa i webbläsare",
        "footerTitle": "Sidfot",
        "unsubscribeTextHelp": "Text för avregistrering",
        "viewInBrowserPlaceholder": "Visa i webbläsare",
        "unsubscribeTextPlaceholder": "Avregistrera från listan",
        "buttonBackgroundColorLabel": "Bakgrund",
        "buttonTextColorLabel": "Text",
        "buttonStyleLabel": "Stil",
        "buttonCornersLabel": "Form",
        "previewTextButton": "Läs mer",
        "bodyBackgroundColorLabel": "Bakgrund",
        "bodyContainerColorLabel": "Innehåll",
        "bodyTextColorLabel": "Text",
        "bodyLinkColorLabel": "Länk",
        "bodyTextExample": "Skapa enkelt nyhetsbrev. Minutemailer förenklar design och skickande av ditt nyhetsbrev. Använd en färdig mall och anpassa designen efter ditt syfte och design. Läs mer på",
        "bodyLinkExample": "minutemailer.com",
        "linksTitle": "Länkar",
        "linksDescription": "Ställ in länkar till sociala medier, din webbplats och mer. Välj design, lägg till dina länkar och välj en ikon.",
        "addLink": "Lägg till länk",
        "helpTextColor": "Färg",
        "helpTextShape": "Form",
        "helpTextSize": "Storlek",
        "fontsTitle": "Eget typsnitt",
        "fontsDescription": "Ladda upp ett eget typsnitt för att göra din design mer likt ditt varumärke. Du kan använda TTF, OTF, WOFF eller WOFF2-filer.",
        "noFonts": "Du har inga egna typsnitt.",
        "buttonUpload": "Ladda upp",
        "fontUploadSuccess": "Teckensnittet har laddats upp.",
        "fontUploadError": "Det gick inte att ladda upp teckensnittet. Använd en TTF, OTF, WOFF eller WOFF2 på högst 10 MB.",
        "fontRemoveSuccess": "Teckensnittet har tagits bort.",
        "fontRemoveError": "Det gick inte att ta bort teckensnittet. Försök igen.",
        "fontsRequirements": "TTF, OTF, WOFF eller WOFF2, upp till 10 MB.",
        "linkSaveFailed": "Det gick inte att spara länken. Försök igen.",
        "linkDeleteFailed": "Det gick inte att ta bort länken. Försök igen.",
        "linkReorderFailed": "Det gick inte att spara den nya ordningen. Försök igen.",
      },
      // Source: resources/assets/js/lang/pages/settings/company/sv.json
      "company": {
        "pageTitle": "Företagsinställningar",
        "companyPublicTitle": "Publik information",
        "companyPublicDescription": "Vi använder den här informationen för att fylla i mallarna och ge dina kontakter användbar information.",
        "companyDisplayName": "Företaget eller organisationens visningsnamn",
        "companyStreetAddress": "Gatuadress",
        "companyPostcode": "Postnummer",
        "companyCity": "Stad",
        "companyCountry": "Land",
        "companyCountryHelp": "Landet där ditt företag är verksamt",
        "companyLanguage": "Företagsspråk",
        "companyLanguageHelp": "Det språk du använder i din kommunikation",
        "teamLang": "Teamets språk",
        "teamLangHelp": "Språk på mallar, avregistreringslänkar, registreringssidor och mer.",
        "companyWebsite": "Hemsidesadress",
        "companyWebsiteHelp": "Lägg till din hemsidesadress eller sociala konto. Behöver vara en giltig url.",
        "companyAboutTitle": "Information om din verksamhet",
        "companyIndustryPlaceholder": "Välj verksamhet",
        "companyAboutDescription": "Inställningarna används för att skapa innehåll till din marknadsföring.",
        "companyIndustryHelp": "Typ av företag eller organisation",
        "otherIndustryOption": "Annat",
        "otherIndustryTitle": "Vilken sorts verksamhet har du?",
        "otherIndustryDescription": "Lägg till vilken typ av verksamhet du har för att hjälpa oss skapa innehåll åt dig.",
        "otherIndustryPlaceholder": "Beskriv din verksamhet",
        "buttonSaveOtherIndustry": "Spara",
        "companyAboutFieldDescription": "Med en eller två meningar, vad gör ditt företag speciellt?",
        "companyAboutFieldPlaceholder": "Vad gör ditt företag speciellt?",
        "teamDeleteTitle": "Ta bort team",
        "teamDeleteDescription": "Detta kommer ta bort ditt team och all data kopplat till ditt team inklusive kontakter, statistik, mallar och bilder.",
        "deleteDeleteButton": "Ta bort teamet",
        "deleteDescription": "För att ta bort ditt team, skriv in team-namnet och klicka på knappen nedan.",
        "deleteTitle": "Ta bort team",
        "deletePlaceholder": "Skriv in team-namnet",
        "buttonDelete": "Ta bort team",
        "buttonCancel": "Avbryt",
        "lastTeamTitle": "Hur du tar bort ditt team",
        "lastTeamDescription": "Du behöver minst ett team. Skapa ett nytt team först, eller om du vill lämna Minutemailer helt kan du radera ditt konto under kontoinställningar.",
      },
      // Source: resources/assets/js/lang/pages/settings/billing/sv.json
      "billing": {
        "pageTitle": "Betalinställningar",
        "buttonChange": "Hantera betalning",
        "buttonUpgrade": "Uppgradera team",
        "buttonChangeVolume": "Ändra plan",
        "buttonChoose": "Välj plan",
        "buttonBuy": "Köp",
        "buttonEarn": "Tjäna",
        "cardTitle": "Betalkort",
        "buttonUpdate": "Uppdatera kort",
        "detailsTitle": "Betalinformation",
        "inputAddress": "Betaladress",
        "inputPostcode": "Postnummer",
        "inputCity": "Stad",
        "inputCountry": "Land",
        "inputVAT": "Momsnummer",
        "tabUpgrade": "Uppgradera team",
        "tabBuy": "Köp krediter",
        "tabEarn": "Tjäna krediter",
        "changePlanTitle": "Ändra plan",
        "changePlanDescription": "Behöver du mer än vad som ingår i din nuvarande plan?",
        "changePlanButton": "Ändra plan",
        "buyCreditsTitle": "Köp krediter",
        "buyCreditsDescription": "Har du en aktiv månad? Fyll på med extra krediter.",
        "buyCreditsButton": "Köp krediter",
        "earnCreditsTitle": "Tjäna krediter",
        "earnCreditsDescription": "Få gratis krediter genom att rekommendera Minutemailer till andra.",
        "earnCreditsButton": "Tjäna krediter",
        "faqTitle": "Frågor om betalningar",
        "questionCredits": "Hur fungerar krediter?",
        "answerCredits": "En kredit motsvarar ett mejl till en person. Så 1 000 krediter räcker till att göra ett utskick till 1 000 kontakter eller till exempel 4 utskick till 250 kontakter. De krediter som ingår i din plan förnyas varje månad. Krediter du köper eller tjänar in går ut efter 24 månader om du inte använder dom eller skaffar nya krediter.",
        "questionPlans": "Hur gör jag om jag behöver skicka fler vad som ingår i min kontoplan?",
        "answerPlans": "Du kan alltid köpa fler krediter om du behöver mer än vad som ingår i den plan du har. Om du behöver mer än de planer vi har eller har specifika behov kan du kontakta oss så hjälper vi dig.",
        "questionCancel": "Kan jag avsluta när jag vill?",
        "answerCancel": "Ja. Du kan avsluta, uppgradera eller nedgradera ditt team när du vill.",
        "questionPay": "Hur betalar jag?",
        "answerPay": "Du kan betala med de flesta bankkort och valutor. Som t ex VISA, Mastercard och American Express. Du kan också använda Apple Pay eller Google Pay om din enhet stödjer det. Vi tar bara emot kortbetalningar online. Alla betalningar sker genom en säker koppling genom vår betalpartner Stripe. Du kan välja att betala i USD, EUR eller SEK. 5% av varje betalning bidrar till att ta bort koldioxid från atmosfären.",
        "questionReceipts": "Var är mina kvitton?",
        "answerReceipts": "Vi skickar kvitton för dina betalningar till kontots e-postadress eller till e-postadressen för betalningar. Du hittar också dina kvitton för din prenumeration i betalportalen. Saknar du ett kvitto kan du alltid kontakta oss så skickar vi det till dig.",
        "questionDiscounts": "Har ni några rabatter?",
        "answerDiscounts": "Våra konton är redan väldigt prisvärda men om du är en icke vinstdrivande organisation, student eller av annan anledning tycker du förtjänar en rabatt kan du kontakta oss så hjälper vi dig. Du kan också bjuda in en vän för att få gratis krediter.",
        "questionNocredits": "Vad händer om mina krediter tar slut?",
        "answerNocredits": "Du kommer inte att kunna skicka mejl om du inte har tillräckligt många krediter. Du kan antingen välja att uppgradera ditt team, köpa fler krediter eller bjuda in vänner för att tjäna krediter.",
        "questionClimate": "På vilket sätt är Minutemailer ett klimatvänligt alternativ?",
        "answerClimate": "Att skicka ett mejl låter som en liten sak men många bäckar små blir lätt en stor flod. Vi vill vara ett klimatvänligt alternativ för att skicka nyhetsbrev. Vi samarbetar därför med betaltjänsten Stripe och använder 5% av det du betalar för att skicka mejl till att rensa koldioxid från atmosfären. Du kan läsa mer om Stripe Climate på deras sajt.",
        "stripeClimate": "Vi samarbetar med betaltjänsten Stripe och använder 5% av det du betalar för att rensa koldioxid från atmosfären.",
        "confirmSubscriptionChangeTitle": "Bekräfta ny plan",
        "confirmSubscriptionChangeTo": "Ändra till",
        "confirmSubscriptionChangePayNow": "Betalas nu",
        "confirmSubscriptionChangeCancel": "Avbryt",
        "confirmSubscriptionChangeButton": "Bekräfta och betala",
        "confirmSubscriptionChangePayNowVAT": "varav :vat moms",
        "perMonth": "månad",
        "perYear": "år",
        "month": "månad",
        "year": "år",
        "nextBilling": " Nästa betalning :periodEnd",
        "cancelAtPeriodEnd": " Avslutas :periodEnd",
        "creditsMonthIncluded": "{0} krediter/månad ingår",
        "leftOnTeamPlanRenews": "{0} kvar på team planen. Förnyas om {1} dagar.",
        "freeAccountLeftover": "{0} kvar från gratiskonto. Giltiga tom {1}.",
        "credits": "{0} krediter",
        "earned": "{0} intjänade",
        "bought": "{0} köpta",
        "historyCardTitle": "Betalningshistorik",
        "tabReceipts": "Kvitton",
        "tabCreditHistory": "Kredithistorik",
        "colDate": "Datum",
        "colDescription": "Beskrivning",
        "colAmount": "Belopp",
        "creditHistoryEmpty": "Ingen kreditaktivitet ännu.",
        "receiptOpenLink": "Öppna kvitto",
        "receiptOpenPdf": "Ladda ner PDF",
        "sourceCharge": "Kreditköp",
        "sourceInvoice": "Prenumeration",
        "tabs": {
          // Source: resources/assets/js/lang/pages/settings/billing/tabs/upgrade/sv.json
          "upgrade": {
            "pageTitle": "Uppgradera team",
            "freeDescription": "Gratis för alltid",
            "freeDescription2": "Du börjar här",
            "buttonDowngrade": "Nedgradera team",
            "buttonUpgrade": "Uppgradera team",
            "buttonCurrent": "Nuvarande plan",
            "buttonChange": "Ändra plan",
            "paymentTerms": "Priser exklusive moms. 1 kredit = 1 mejl till 1 kontakt. Ingen uppsägningstid.",
            "currencyText": "Valuta",
            "selectYearly": "med årsvis betalning",
            "perMonth": "/månad",
            "perYear": "/year",
            "saveMonths": "Spara 2 månader",
            "selectMonthly": "Betala per månad",
            "faqTitle": "Frågor om att uppgradera ditt team",
            "questionLimit": "Vad händer om jag går över min kreditgräns?",
            "answerLimit": "Oroa dig inte. Om du skickar mer än din plan tillåter eller din kontaktlista växer säger vi till och du kan antingen uppgradera teamet eller köpa krediter som kan användas för att skicka mejl. Du kan också bjuda in vänner för att tjäna krediter.",
            "questionFree": "Vad ingår i gratisplanen?",
            "answerFree": "Gratisplanen har all funktionalitet som de betalda planerna men är includerar enbart 100 krediter per månad och har inte prioriterad eller premium support.",
            "questionPayperemail": "Kan jag betala per utskick istället för per månad?",
            "answerPayperemail": "Ja. Du kan köpa krediter och använda dom för att skicka mejl. Även på gratisplanen.",
            "questionCancel": "Kan jag avsluta när jag vill?",
            "answerCancel": "Ja. Du kan avsluta, nedgradera eller uppgradera när du vill.",
            "questionHowtopay": "Hur betalar jag?",
            "answerHowtopay": "Du kan betala med de flesta bankkort. Som t ex VISA, Mastercard och American Express. Vi tar enbart emot kortbetalningar online. Alla betalningar sker genom en säker koppling via vår betalpartner Stripe.",
            "questionDiscounts": "Har ni några rabatter?",
            "answerDiscounts": "Om du är en icke vinstdrivande organisation, student eller av annan orsak tycker du förtjänar en rabatt, kontakta oss så hjälper vi dig. Du kan också bjuda in vänner för att tjäna gratis krediter om du har en liten budget.",
            "customAccountTitle": "Behöver du mer? Skaffa Premium",
            "customAccountText": "I Premium ingår allt i Business plus en anpassad kreditplan, Premium onboarding, telefonsupport under arbetstid och möjlighet till egen IP adress för bättre leverans av nyhetsbrev.",
            "customAccountButtonText": "Chatta med oss",
            "customAccountButtonCall": "Eller 📞 Ring",
            "featuresBuyCredits": "Köp krediter om du behöver mer",
            "featuresUnlimitedContacts": "Obegränsat med kontakter",
            "featuresUnlimitedStats": "Obegränsad historik",
            "featuresLimitedStats": "30 dagars historik",
            "featuresUnlimitedTeamMembers": "Obegränsade team medlemmar",
            "featuresLimitedTeamMembers": "3 team medlemmar",
            "featuresAiImprovements": "AI förbättringar ✨",
            "featuresSendFiles": "Skicka filer",
            "featuresPrioritySupport": "Prioriterad support",
            "featuresMinutemailerBadge": "Minutemailer avsändare i mejl",
            "upgradeCreditsPerMonth": "{0} krediter per månad",
            "chooseVolume": "Hur många mejl skickar du per månad?",
            "suggestedPlan": "Föreslagen plan",
            "buttonChoose": "Fortsätt",
          },
          // Source: resources/assets/js/lang/pages/settings/billing/tabs/earn/sv.json
          "earn": {
            "pageTitle": "Tjäna krediter",
            "titleInvite": "Bjud in en vän och tjäna krediter",
            "descriptionInvite": "Både du och din vän får krediter när din vän registrerar ett konto med din länk. 1 000 krediter för en registrering. 1 000 krediter för första mejlet som skickas och 5% av värdet (i krediter, minst 2 000 krediter) på första köpet av krediter eller uppgradering av konto. Du kan följa ditt resultat på den här sidan.",
            "shareText": "Jag använder Minutemailer för att skicka nyhetsbrev. Gör det du också. Skaffa ett konto och få 1 000 gratis krediter att skicka mejl för.",
            "linkedinText": "bjuder in dig till Minutemailer",
            "hashtagEmailmarketing": "#nyhetsbrev",
            "earnedCredits": "+{0} krediter",
            "buttonEmail": "Skapa mejl",
            "buttonFacebook": "Dela på Facebook",
            "buttonTwitter": "Dela på Twitter",
            "buttonLinkedin": "Dela på Linkedin",
            "titleEarned": "Intjänade krediter",
            "faqTitle": "Frågor om att tjäna krediter",
            "questionHow": "Hur tjänar jag krediter?",
            "answerHow": "Använd din unika inbjudingslänk för att bjuda in vänner och kontakter till Minutemailer. Skicka ett trevligt mejl, dela en länk på sociala medier eller skriv ut ett flygblad. Alla som registrerar ett konto med din länk ger både dig och din vän 1 000 extra krediter som du kan använda för att skicka mejl.",
            "questionUse": "Vad jag kan använda krediter till?",
            "answerUse": "Du kan använda krediter för att skicka e-post. 100 krediter = 1 skickat mejl till 100 kontakter eller om du vill 2 mejl till 50 kontakter vardera gång.",
            "questionLimit": "Finns det någon gräns för hur många krediter jag kan tjäna?",
            "answerLimit": "Nej, du kan bjuda in hur många personer du vill och i teorin tjäna oändligt många krediter som läggs till ditt konto.",
            "questionExpire": "Kommer mina intjänade krediter gå ut?",
            "answerExpire": "Ja, om du inte använder dom eller tjänar in nya så går de ut efter 24 månader.",
          },
          // Source: resources/assets/js/lang/pages/settings/billing/tabs/buy/sv.json
          "buy": {
            "pageTitle": "Köp krediter",
            "numberCredits": "Antal krediter",
            "amountPay": "Summa att betala",
            "buttonBuy": "Köp",
            "buttonAdd": "Lägg till",
            "faqTitle": "Frågor om att köpa krediter",
            "questionUse": "Vad kan jag använda krediter till?",
            "answerUse": "Du kan använda krediter för att skicka e-post. 100 krediter = 1 skickat mejl till 100 kontakter eller om du vill 2 mejl till 50 kontakter vardera gång.",
            "questionExpire": "Går mina köpta krediter ut?",
            "answerExpire": "Ja, om du inte använder dom eller köper nya så går de ut efter 24 månader.",
            "questionDifference": "Vad är skillnaden mellan att köpa krediter och uppgradera?",
            "answerDifference": "Om du uppgraderar ditt konto får du fler krediter inkluderade varje månad. Vilket är bra om du skickar ungefär lika många mejl varje månad. Krediter är bra om du behöver skicka mer en viss period eller om ett uppgraderat konto inkluderar fler krediter än du behöver.",
            "questionPay": "Hur betalar jag?",
            "answerPay": "Du kan betala med de flesta bankkort som VISA, Mastercard och American Express. Vi stödjer ej banköverföringar eller andra former av betalningar.",
            "paymentTerms": "Priser exklusive moms. 1 kredit = 1 mejl till 1 kontakt. Ingen uppsägningstid.",
            "currencyText": "Valuta",
            "choosePackage": "Lägg till det antal krediter du behöver",
          },
        },
      },
      // Source: resources/assets/js/lang/pages/settings/api/sv.json
      "api": {
        "pageTitle": "API-inställningar",
        "apiDescription": "Skapa en API-token för tillgång till vårt API. Var noga med att kopiera din token då den bara kan läsas en gång. Använd Minutemailer API:et för att integrera Minutemailer med din app.",
        "apiReadMore": "Läs mer om Minutemailer API:et",
        "apiReadMoreurl": "https://www.minutemailer.com/sv/developers",
        "apiCreateToken": "Skapa API-token",
        "apiFirstToken": "Välj 'Skapa API-token' för att skapa din första token",
        "createTitle": "Skapa en token",
        "createDescription": "Ge din API-token ett namn.",
        "createPlaceholder": "t.ex. Min integration",
        "createError": "Du måste ge token ett namn",
        "tokenText": "Gör en kopia av din token. På grund av säkerhetsskäl kan du bara se token en gång. Om du tappar bort den behöver du skapa en ny API-token.",
        "buttonClose": "Stäng",
        "tokenCreated": "Token skapad",
        "revokeDescription": "Alla integrationer som använder den här token kommer sluta fungera. Är du säker på att du vill återkalla den här token?",
        "revokeTitle": "Återkalla token?",
        "buttonRevoke": "Återkalla",
        "copyTitle": "Kopiera token",
        "copiedTitle": "Token kopierad",
        "copiedDescription": "Token har kopierats till ditt urklipp. Spara den på ett säkert ställe.",
        "tableName": "Namn",
        "tableLastused": "Senast använd",
        "tokenRevoked": "Token återkallad!",
        "never": "Aldrig",
        "mcp": {
          "title": "AI-assistenter (MCP)",
          "description": "Teammedlemmar kan ansluta AI-assistenter som Claude, ChatGPT och Cursor till det här teamet. Varje app kan bara göra det som medlemmens roll tillåter.",
          "manageOwn": "Anslut eller koppla bort dina egna appar i dina kontoinställningar.",
          "tableMember": "Medlem",
          "tableApp": "App",
          "empty": "Inga AI-appar är anslutna till det här teamet än.",
          "loadError": "Det gick inte att ladda de anslutna apparna.",
          "retry": "Försök igen",
        },
      },
      // Source: resources/assets/js/lang/pages/settings/account/sv.json
      "account": {
        "pageTitle": "Kontoinställningar",
        "accountPersonalSettingsTitle": "Dina personliga inställningar",
        "accountPersonalSettingsDescription": "Används för att ge dig en bättre upplevelse som användare genom att ställa in språk på gränssnittet samt tid- och datum format. Syns ej publikt någonstans.",
        "accountYourName": "Ditt namn",
        "accountPrefLang": "Gränssnittsspråk",
        "accountTimezone": "Din tidszon",
        "accountTimeFormat": "Tids formatering",
        "accountDateFormat": "Datum formatering",
        "accountEmailAddress": "Din e-postadress",
        "accountEmailAddressDescription": "Gå till dina e-postinställningar för att ändra ditt kontos e-postadress eller lägga till fler e-postadresser att skicka från.",
        "accountEmailAddressButton": "E-postinställningar",
        "accountPasswordTitle": "Ändra ditt lösenord",
        "accountPasswordDescription": "Skriv in ett nytt lösenord två gånger. Skriv sedan in ditt nuvarande lösenord och tryck på 'Spara ändringar'.",
        "accountPasswordNew": "Nytt lösenord",
        "accountPasswordRepeatNew": "Repetera det nya lösenordet",
        "accountPasswordCurrent": "Ditt nuvarande lösenord",
        "accountPasswordSave": "Spara ändringar",
        "accountPasswordSuccess": "Ditt lösenord har uppdaterats!",
        "accountNotifications": "Meddelanden",
        "accountNotificationsDescription": "Välj vilka typer av meddelanden du vill få från Minutemailer.",
        "accountNotificationsNews": "Nyheter, tips och guider via e-post",
        "accountNotificationsWeekly": "Veckostatistik via e-post",
        "accountDeleteTitle": "Radering av ditt konto",
        "accountDeleteDescription": "Varning! All din data inklusive tillgång till teams kommer försvinna om du raderar ditt konto.",
        "accountDeleteButton": "Ja, radera mitt konto",
        "accountDowngradeButton": "Nedgradera till ett gratiskonto",
        "deleteTitle": "Är du säker på att du vill radera ditt konto?",
        "deleteDescription": "Detta kommer ta bort ditt konto och all data och kan inte ångras. Skriv in ditt lösenord för att bekräfta.",
        "deletePlaceholder": "Nuvarande lösenord",
        "buttonDelete": "Radera konto",
        "buttonCancel": "Avbryt",
        "deleteError": "Något gick fel, kontakta vår support",
        "connected_accounts": {
          "title": "Anslutna konton",
          "description": "Logga in på Minutemailer via en ansluten leverantör utöver ditt lösenord.",
          "connected": "Ansluten",
          "not_connected": "Inte ansluten",
          "connect": "Anslut",
          "disconnect": "Koppla bort",
          "disconnect_blocked_set_password": "Sätt ett lösenord innan du kopplar bort din enda inloggningsmetod.",
        },
        "connected_apps": {
          "title": "Anslutna appar",
          "description": "Låt AI-assistenter som Claude, ChatGPT och Cursor arbeta med dina utskick och kontakter. Lägg till Minutemailer som anslutning i appen med adressen nedan, logga sedan in och välj ett team.",
          "readMore": "Läs guiden om AI-assistenter",
          "readMoreUrl": "https://www.minutemailer.com/sv/guides/ai-assistants/",
          "serverUrl": "Serveradress",
          "copy": "Kopiera",
          "copied": "Kopierad",
          "empty": "Inga appar är anslutna till ditt konto än.",
          "loadError": "Det gick inte att ladda de anslutna apparna.",
          "retry": "Försök igen",
          "lastUsed": "Senast använd",
          "notUsed": "Inte använd än",
          "unknownApp": "Okänd app",
          "disconnect": "Koppla bort",
          "disconnectTitle": "Koppla bort :app?",
          "disconnectDescription": "Appen förlorar direkt åtkomsten till :team. Du kan ansluta den igen när du vill.",
          "disconnectError": "Det gick inte att koppla bort appen. Försök igen.",
        },
      },
    },
    // Source: resources/assets/js/lang/pages/result/sv.json
    "result": {
      "title": "Resultat",
      "labelSent": "skickade",
      "labelDelivered": "1 levererad|{0} levererade",
      "labelUndelivered": "1 olevererad|{0} olevererade",
      "labelDropped": "1 tappad|{0} tappade",
      "labelUnsubscribed": "1 avregistrerad|{0} avregistrerade",
      "labelOpenrate": "{0} öppningsfrekvens",
      "labelClickrate": "{0} klickfrekvens",
      "labelBounces": "1 studs|{0} studsade",
      "labelSpam": "{0} skräppost",
      "titleLatest": "Ditt senaste utskick",
      "buttonView": "Visa",
      "emailFrom": "Från",
      "emailTo": "Till",
      "emailSubject": "Ämne",
      "emailWhen": "När",
      "sentOverTime": "Skickat över tid",
      "wasScheduled": "Var schemalagt",
      "labelOpen": "1 öppnad|{0} öppnade",
      "labelClicked": "1 klickad|{0} klickade",
      "labelBounced": "1 studs|{0} studsade",
      "view_result": "Visa resultat",
      "tableSubject": "Ämne",
      "tableStatus": "Status",
      "tableFrom": "Från",
      "tableTo": "Till",
      "tableWhen": "När",
      "tableEmail": "E-post",
      "tableName": "Namn",
      "tableTime": "Tid",
      "tableComment": "Kommentar",
      "tableFeedback": "Feedback",
      "clickedOn": "Klickat på :url",
      "buttonExport": "Exportera rapport",
      "buttonDuplicate": "Duplicera och redigera",
      "buttonDelete": "Radera",
      "buttonCancel": "Avbryt",
      "delete": "Ta bort",
      "duplicate": "Duplicera",
      "buttonSaveAsTemplate": "Spara som mall",
      "titleDelete": "Vill du ta bort det här mejlet?",
      "descriptionDelete": "Om du tar bort mejlet kan du inte få tillbaka det.",
      "showingFilter": "Visar :contacts kontakter som har",
      "titlePreview": "Förhandsvisning av mejl",
      "menuDelivered": "Levererats till",
      "menuOpen": "Öppnats av",
      "menuClicked": "Klickats av",
      "menuSpam": "Markerat som skräppost",
      "menuBounce": "Kontakter som studsat",
      "menuUnsubscribed": "Avregistrerats av",
      "menuLinks": "Länkar som har klickats på",
      "emptystateNothingsent": "Du har inte skickat något",
      "buttonCreate": "Skapa mejl",
      "buttonShowmore": "Visa fler",
      "feedbackOnThisEmail": "Feedback på ditt utskick",
      "labelBadFeedback": ":count negativa",
      "labelGoodFeedback": ":count positiva",
      "deletedContact": "Borttagen kontakt",
      "hideAnswers": "Göm svar",
      "showAnswers": "Visa svar",
      "urlAddress": "Länk",
      "clicks": "Klick",
      "limitedStatsMessage": "Uppgradera din plan för att se utskick äldre än 30 dagar.",
      "showingLimitedStats": "Visar historik för senaste 30 dagarna.",
      "limitedStatsUpgrade": "Uppgradera din plan",
      "limitedStatsSeeMore": "för att se mer",
      "feedbackRatingTitle": "Betyg",
      "feedbackRatingBasedOn": "Baserat på :count svar",
      "labelDetractors": "kritiker",
      "labelPassive": "passiva",
      "labelPromoters": "ambassadörer",
      "labelNPSScore": ":count svar",
      "today": "Idag",
      "lastDays": "Senaste :days dagarna",
      "lastWeeks": "Senaste :weeks veckorna",
      "lastMonths": "Senaste :months månaderna",
      "allTime": "Alltid",
      "noFeedbackYet": "Ingen feedback än",
      "headlineSummary": "Sammanfattning och förslag",
      "headlineAboutresult": "Om resultatet",
      "descriptionTextresult": "Skickade mejl: antal mejl som försökt skickas. Levererade mejl: antal faktiskt levererade mejl. Öppnade mejl: spårade öppningar, även om antalet kan vara lägre på grund av att vissa e-postklienter blockerar spårning. Studsade mejl: kan uppstå av olika anledningar.",
      "linkDelivery": "Läs mer om leveranser och statistik",
      "tabResult": "Resultat",
      "tabFeedback": "Feedback",
      "tabEmail": "Visa mejl",
      "tabRecipients": "Mottagare och klick",
      "export": "Ladda ned",
      "search": "Sök",
      "sentEmailsTitle": "Skickade mejl",
      "sentEmailsCount": "{0} utskick|{0} utskick",
      "newDraft": "Skapa mejl",
      "buttonViewInBrowser": "Visa & dela mejl",
      "tabSent": "Skickade",
      "tabAutomation": "Autopilot",
      "tabDrafts": "Utkast",
      "tabScheduled": "Schemalagda",
      "statsSent": "Skickade",
      "statsDelivered": "Levererade",
      "statsBounced": "Studsade",
      "statsOpened": "Öppnade",
      "statsClicked": "Klickade",
      "statsUnsubscribed": "Avregistrerade",
      "searchPlaceholder": "Sök",
      "countDrafts": "utkast",
      "countScheduled": "schemalagda",
      "countEmails": "mejl",
      "buttonSuggest": "Föreslå mejl",
      "buttonSave": "Spara",
      "columnName": "Namn",
      "columnSubject": "Ämne",
      "columnStatus": "Status",
      "columnRecipients": "Mottagare",
      "columnFrom": "Från",
      "columnLastEdited": "Senast redigerad",
      "columnScheduledFor": "Schemalagd till",
      "columnDate": "Datum",
      "statusSent": "Skickat",
      "statusSending": "Skickar",
      "statusScheduled": "Schemalagt",
      "statusFailed": "Misslyckades",
      "untitled": "Namnlös",
      "menuEdit": "Redigera",
      "menuDuplicate": "Duplicera",
      "menuCancel": "Avbryt schemaläggning",
      "menuDelete": "Ta bort",
      "menuResend": "Skicka igen",
      "menuRevertToDraft": "Återställ till utkast",
      "resendTitle": "Skicka det här mejlet igen?",
      "resendDescription": "Mejlet har inte skickats till leverantören. Det läggs i kön för att skickas nu.",
      "revertToDraftTitle": "Återställ mejlet till ett utkast?",
      "revertToDraftDescription": "Detta rensar den misslyckade sändningen och flyttar mejlet till Utkast.",
      "deleteDescription": "Om du tar bort mejlet kan du inte få tillbaka det.",
      "deleteTitle": "Vill du ta bort det här mejlet?",
      "toastDeleted": "Mejl borttaget",
      "toastDeleteFailed": "Kunde inte ta bort mejlet",
      "toastCancelled": "Schemalagt mejl avbrutet",
      "toastCancelFailed": "Kunde inte avbryta schemalagt mejl",
      "toastResent": "Mejlet har lagts i kön för att skickas igen",
      "toastResendFailed": "Kunde inte skicka mejlet igen",
      "toastRevertedToDraft": "Mejlet har återställts till utkast",
      "toastRevertToDraftFailed": "Kunde inte återställa mejlet till utkast",
      "noSearchResults": "Inga resultat hittades",
      "noEmails": "Inga mejl än",
      "buttonLoadMore": "Ladda fler",
      "buttonLoading": "Laddar...",
      "performanceExcellent": "Utmärkt resultat!",
      "performanceGood": "Bra resultat!",
      "performanceAverage": "Godkänt resultat",
      "performanceNeedsImprovement": "Under genomsnittet",
      "performancePoor": "Lågt resultat",
      "archivedRatesUnavailable": "Statistiken är slutgiltig. Öppnings- och klickfrekvens kan inte beräknas utan registrerade leveranser.",
      "performanceDescription": "Ditt utskick uppnådde :openRate% öppningsfrekvens (15–25% är normalt) och :clickRate% klickfrekvens (2–5% är normalt). :unopened kontakter har ännu inte öppnat mejlet. Öppningsfrekvensen kan vara högre då vissa mejlklienter blockerar spårning.",
      "waitingForStats": "Samlar in statistik",
      "waitingForStatsDescription": "Statistiken uppdateras automatiskt när leveranser och engagemang registreras.",
      "accordionStatistics": "Statistik",
      "accordionEngagement": "Engagemang",
      "accordionBounced": "Studsade",
      "bounceReason": "Orsak",
      "bounceReasonOld": "Leveransen misslyckades tills tiden gick ut. Inkorgen kan vara full eller inaktiv.",
      "bounceReasonBounce": "Mottagarens e-postserver avvisade meddelandet. Adressen finns förmodligen inte.",
      "bounceReasonGeneric": "Meddelandet avvisades av mottagarens e-postserver.",
      "bounceReasonHardfail": "Mottagarens e-postserver avvisade meddelandet permanent.",
      "bounceReasonEspblock": "Mottagarens e-postleverantör blockerade meddelandet.",
      "bounceReasonSuppressBounce": "Adressen har studsat tidigare, så meddelandet skickades inte för att skydda ditt avsändarrykte.",
      "bounceReasonSuppressComplaint": "Mottagaren har tidigare markerat ett mejl som skräppost, så meddelandet skickades inte.",
      "bounceReasonSuppressUnsubscribe": "Mottagaren har tidigare avregistrerat sig, så meddelandet skickades inte.",
      "accordionLinks": "Klickade länkar",
      "accordionRecipients": "Mottagare",
      "accordionFeedback": "Feedback",
      "score": "Poäng",
      "noLinksYet": "Inga klickade länkar än",
      "feedbackPositive": "Positiv",
      "feedbackNegative": "Negativ",
      "feedbackScore": "Betyg",
      "feedbackResponses": ":count svar",
      "feedbackAvgRating": "Snitt :score av :max",
      "feedbackNpsScore": "NPS-poäng: :score",
      "selectAll": "Markera alla",
      "selectNone": "Avmarkera alla",
      "deleteSelected": "Ta bort markerade",
      "deleteSelectedTitle": "Ta bort :count mejl?",
      "deleteSelectedDescription": "Det här kan inte ångras.",
      "youAreEditingThisEmail": "Du redigerar detta utkast",
      "someoneElseIsEditingThisEmail": ":name redigerar detta utkast",
      "paywallDescription": "Du ser mejl från de senaste 30 dagarna. Uppgradera för att se hela din mejlhistorik och låsa upp:",
      "automationCreate": "Skapa ny",
      "automationCreateTitle": "Skapa ny autopilot",
      "automationEditTitle": "Redigera autopilot",
      "automationActivate": "Aktivera",
      "automationTestAndActivate": "Testa & aktivera",
      "automationNameLabel": "Namn",
      "automationNamePlaceholder": "Välkomstmejl",
      "automationDescriptionLabel": "Beskrivning",
      "automationDescriptionPlaceholder": "En kort intern anteckning",
      "automationTriggerLabel": "Skicka när",
      "automationWaitAmountLabel": "Vänta",
      "automationWaitUnitLabel": "Enhet",
      "automationTargetLabel": "Målgrupp",
      "automationTargetContacts": "Alla kontakter",
      "automationTargetCount": "1 kontakt|:count kontakter",
      "automationTemplatesDesigned": "Designat",
      "automationTemplatesDesignedDescription": "Visuella automatiserade mejl",
      "automationTemplatesPlainText": "Bara text",
      "automationTemplatesPlainTextDescription": "Enkla automatiserade textmejl",
      "automationEnabledLabel": "Aktiv",
      "automationStatusActive": "Aktiv",
      "automationStatusPaused": "Pausad",
      "automationFromInfo": "Avsändaradressen hanteras i dina teaminställningar.",
      "automationTriggerVerifiedSubscriber": "Verifierad prenumerant",
      "automationWaitUnitMinutes": "minut|minuter",
      "automationWaitUnitHours": "timme|timmar",
      "automationWaitUnitDays": "dag|dagar",
      "automationWaitUnitWeeks": "vecka|veckor",
      "automationRepeatFrequencyLabel": "Upprepas",
      "automationRepeatFrequencyDaily": "Dagligen",
      "automationRepeatFrequencyWeekly": "Veckovis",
      "automationRepeatFrequencyMonthly": "Månadsvis",
      "automationRepeatEveryLabel": "Varje",
      "automationRepeatOnLabel": "På",
      "automationRepeatAtLabel": "Klockan",
      "automationRepeatRecipientsLabel": "Mottagare",
      "automationRepeatSendOncePerContact": "Skicka en gång per kontakt",
      "automationRepeatSendOncePerContactHelpOn": "Varje kontakt får mejlet en gång. Vid varje utskick når det bara personer i målgruppen som inte redan fått det, även nytillagda och importerade kontakter.",
      "automationRepeatSendOncePerContactHelpOff": "Varje utskick går till alla i målgruppen, även de som redan fått det.",
      "automationRepeatAudienceNew": "till nya kontakter som inte redan fått det",
      "automationRepeatAudienceAll": "till alla i målgruppen",
      "automationRepeatSummary": ":schedule, :audience.",
      "automationRepeatTimezone": "Tidszon :timezone",
      "automationRepeatDayUnit": "dag|dagar",
      "automationRepeatWeekUnit": "vecka|veckor",
      "automationRepeatMonthUnit": "månad|månader",
      "automationRepeatFirst": "första",
      "automationRepeatSecond": "andra",
      "automationRepeatThird": "tredje",
      "automationRepeatFourth": "fjärde",
      "automationRepeatLast": "sista",
      "automationRepeatDailySummary": "Dagligen kl :time",
      "automationRepeatDailyIntervalSummary": "Var :interval:e dag kl :time",
      "automationRepeatWeeklySummary": "Veckovis på :days kl :time",
      "automationRepeatWeeklyIntervalSummary": "Var :interval:e vecka på :days kl :time",
      "automationRepeatMonthlySummary": "Månadsvis på :position :weekday kl :time",
      "automationRepeatMonthlyIntervalSummary": "Var :interval:e månad på :position :weekday kl :time",
      "automationDelay": ":amount :unit",
      "automationRunsImmediately": "Kör direkt efter :trigger",
      "automationRunsAfter": "Kör :delay efter :trigger",
      "automationStatsAutomations": "Autopiloter",
      "automationHelpText": "Autopiloter är mejl som skickas automatiskt till dina kontakter vid rätt tillfälle.",
      "automationStatsEnabled": "Aktiva",
      "automationSent": "skickade",
      "automationOpened": "öppnade",
      "automationClicked": "klickade",
      "automationLastSent": "Senast skickad",
      "automationNextSend": "Nästa utskick",
      "automationProjectedRecipients": "Beräknade mottagare",
      "automationEmpty": "Inga autopiloter än",
      "automationSaved": "Autopilot sparad",
      "automationSaveFailed": "Kunde inte spara autopilot",
      "automationCreateFailed": "Kunde inte skapa autopilot",
      "automationDeleted": "Autopilot borttagen",
      "automationDeleteFailed": "Kunde inte ta bort autopilot",
      "automationDeleteTitle": "Ta bort autopilot?",
      "automationDeleteDescription": "Autopiloten kommer sluta skicka mejl automatiskt.",
      "automationDuplicated": "Autopilot duplicerad",
      "automationDuplicateFailed": "Kunde inte duplicera autopilot",
      "automationCopySuffix": "kopia",
      "automationToggleLabel": "Aktivera :name",
      "automationNoEngagementCriteria": "Inaktiv i",
      "automationNoEngagementEmails": "mejl under de senaste",
      "automationNoEngagementScheduleToggle": "Skicka vid specifik tidpunkt",
      "automationNoEngagementDayLabel": "Följande",
      "preliminaryPerformance": "Preliminära resultat",
      "preliminaryPerformanceDescription": "Leveranser och engagemang fortsätter att komma in. Resultatpoängen kan ändras.",
    },
    // Source: resources/assets/js/lang/pages/reset-password/sv.json
    "reset-password": {
      "headline": "Återställ lösenord",
      "email_placeholder": "Din e-postadress",
      "email_example": "namn@exempel.se",
      "password_placeholder": "Nytt lösenord",
      "password_confirm_placeholder": "Bekräfta nytt lösenord",
      "submit": "Återställ lösenord",
      "required": "Fältet är obligatoriskt",
    },
    // Source: resources/assets/js/lang/pages/register/sv.json
    "register": {
      "headline": "Starta ditt gratiskonto",
      "preamble": "Få fler återkommande kunder. Allt du behöver för mejlmarknadsföring och nyhetsbrev.",
      "intent_headline": "Ditt mejl är nästan klart",
      "intent_preamble": "Skapa ditt konto så fortsätter vi där du slutade.",
      "name_placeholder": "Ditt namn",
      "email_placeholder": "Din e-postadress",
      "email_example": "namn@exempel.se",
      "password_placeholder": "Lösenord",
      "company_placeholder": "Namn på ditt företag eller organisation",
      "country_placeholder": "Företaget eller organisationens land",
      "submit": "Fortsätt",
      "free_allowance": "Gratis upp till 1 000 mejl i månaden",
      "no_credit_card": "Inget kreditkort behövs",
      "termsText": "Genom att fortsätta så godkänner du vår ",
      "termsLink": "anti-spam policy samt användarvillkor.",
      "invited": "Du har blivit inbjuden att starta ett gratis konto på Minutemailer av :name. Genom att gå med genom den här länken får du 1 000 extra krediter att skicka mejl för.",
      "teamInvite": "Du har blivit inbjuden till teamet :to på Minutemailer av :name. Genom att gå med genom den här länken får du 1 000 extra krediter till ditt personliga konto och 1 000 extra krediter till ditt team att skicka mejl för.",
      "already_have_account": "Har du redan ett konto?",
      "login": "Logga in",
      "google_signup": "Registrera med Google",
      "or_continue_with_email": "Eller",
      "generic_error": "Något gick fel och ditt konto skapades inte. Försök igen.",
    },
    // Source: resources/assets/js/lang/pages/pages/sv.json
    "pages": {
      "pageTitle": "Sidor",
      "searchPlaceholder": "Sök sidor",
      "buttonCreate": "Skapa sida",
      "countPages": "sidor",
      "columnName": "Sida",
      "columnType": "Typ",
      "columnSlug": "Slug",
      "columnUrl": "URL",
      "columnUpdated": "Uppdaterad",
      "menuEdit": "Redigera",
      "menuDuplicate": "Duplicera",
      "menuCopyUrl": "Kopiera URL",
      "menuCopyEmbedCode": "Kopiera inbäddningskod",
      "menuOpenPublished": "Öppna publicerad sida",
      "noPages": "Inga sidor än",
      "noSearchResults": "Inga sidor matchar din sökning",
      "toastCreateFailed": "Kunde inte skapa sida",
      "buttonClose": "Stäng",
      "savingChanges": "Sparar ändringar",
      "changesSaved": "Ändringar sparade",
      "changesMade": "Ändringar gjorda",
      "errorSaving": "Kunde inte spara ändringar",
      "noChanges": "Inga ändringar",
      "buttonPreview": "Förhandsvisa",
      "buttonPublish": "Publicera",
      "buttonOpen": "Öppna",
      "buttonEditBreakpoints": "Redigera brytpunkter",
      "buttonBack": "Tillbaka",
      "buttonVersions": "Versioner",
      "publishing": "Publicerar",
      "currentVersion": "Aktuell",
      "versionsCount": "1 version|:count versioner",
      "menuRollbackVersion": "Återgå till v:version",
      "previewTitle": "Förhandsvisning av sida",
      "typePage": "Sida",
      "typeForm": "Formulär",
      "typePopup": "Popup",
      "statusDraft": "Utkast",
      "statusPublished": "Publicerad v:version",
      "editorTitle": "Redigera sida",
      "titleSmallScreen": "Använd en större skärm",
      "descriptionSmallScreen": "Sidredigeraren är tillgänglig på surfplattor och datorer.",
      "imageActionCreate": "Skapa egen bild",
      "imageActionUpload": "Ladda upp",
      "imageActionChoose": "Välj",
      "addImageButton": "Lägg till bild",
      "templateChooserTitle": "Skapa",
      "templateSectionPage": "Sida",
      "templateSectionPageDescription": "Skapa en fristående sida",
      "templateSectionForms": "Formulär",
      "templateSectionFormsDescription": "Skapa ett formulär eller popup-formulär",
      "templateTypePopup": "Popup-formulär",
      "menuDelete": "Ta bort",
      "deleteTitle": "Ta bort sida?",
      "deleteDescription": "Sidan tas bort permanent. Det går inte att ångra.",
      "buttonDelete": "Ta bort",
      "buttonCancel": "Avbryt",
      "toastDuplicated": "Sida duplicerad",
      "toastDuplicateFailed": "Kunde inte duplicera sida",
      "toastDeleted": "Sida borttagen",
      "toastDeleteFailed": "Kunde inte ta bort sida",
      "toastPublished": "Sida publicerad",
      "toastPublishFailed": "Kunde inte publicera sida",
      "toastRolledBack": "Publicerad version ändrad",
      "toastRollbackFailed": "Kunde inte återställa sida",
      "toastUrlCopied": "URL kopierad",
      "toastEmbedCodeCopied": "Inbäddningskod kopierad",
    },
    "onboarding": {
      // Source: resources/assets/js/lang/pages/onboarding/1/sv.json
      "1": {
        "headline": "Hej och välkommen! Nu sätter vi upp ditt konto och hjälper dig med ditt första nyhetsbrev.",
        "text": "Låt oss börja med det enklaste.",
        "nameLabel": "Ditt namn",
        "namePlaceholder": "Ditt namn",
        "websiteLabel": "Webbplats",
        "websitePlaceholder": "dittforetag.se",
        "websiteHelp": "Valfritt. Vi använder den för att fylla i dina företagsuppgifter automatiskt. Lämna tom om du inte har någon.",
        "websiteOpen": "Öppna webbplatsen i en ny flik",
        "continue": "Sätt igång!",
        "continueLoading": "Hämtar dina företagsuppgifter…",
      },
      // Source: resources/assets/js/lang/pages/onboarding/2/sv.json
      "2": {
        "headline": "Berätta om ditt företag",
        "text": "Vi behöver bara några detaljer för att bättre kunna hjälpa dig med dina mejl.",
        "businessNameLabel": "Företagsnamn",
        "businessNamePlaceholder": "Namn på företag eller organisation",
        "industryLabel": "Vilken typ av verksamhet har du?",
        "industryPlaceholder": "Välj typ av verksamhet",
        "otherPlaceholder": "Beskriv din typ av verksamhet",
        "descriptionLabel": "Vad gör ditt företag speciellt?",
        "descriptionPlaceholder": "Beskriv kort vad ditt företag gör och vad som gör det unikt.",
        "reviewShow": "Granska och ändra uppgifter vi fyllt i",
        "reviewHide": "Dölj uppgifter",
        "languageLabel": "Företagsspråk",
        "languagePlaceholder": "Företagsspråk",
        "countryLabel": "Land",
        "countryPlaceholder": "Land",
        "back": "Tillbaka",
        "continue": "Nästa",
      },
      // Source: resources/assets/js/lang/pages/onboarding/3/sv.json
      "3": {
        "headline": "Nu ska vi äntligen skapa ditt första fantastiska mejl.",
        "text": "Vad är syftet eller målet med ditt nyhetsbrev?",
        "text2": "Beskriv kort vad du vill berätta om i mejlet.",
        "aboutPlaceholder": "Beskriv vad ditt mejl handlar om",
        "back": "Tillbaka",
        "preComplete": "Skapa mejl",
        "complete": "Visa mitt mejl",
        "completeSkip": "Kom igång",
        "skip": "Hoppa över",
        "headlineTrial": "Testa Minutemailer PRO i 14 dagar gratis!",
        "textTrial": "Testa hela Minutemailer upplevelsen. Efter 14 dagar kan du välja att uppgradera till en betalplan eller stanna på gratisplanen.",
        "plansInclude": "Alla betalplaner inkluderar:",
      },
      // Source: resources/assets/js/lang/pages/onboarding/team-info/sv.json
      "team-info": {
        "headline": "Berätta mer",
        "text": "Berätta mer om ditt team för att skapa en bättre upplevelse från start.",
        "businessNamePlaceholder": "Namn på ditt företag eller organisation",
        "addressPlaceholder": "Adress",
        "cityPlaceholder": "Stad",
        "statePlaceholder": "Region",
        "zipPlaceholder": "Postnummer",
        "countryPlaceholder": "Land",
        "websitePlaceholder": "Webbsajt",
        "continue": "Nästa",
        "skip": "Hoppa över",
        "optional": "Valfri",
      },
      // Source: resources/assets/js/lang/pages/onboarding/team/sv.json
      "team": {
        "headline": "Skapa ett team",
        "text": "Skapa ett team för ditt företag eller organisation. Döp det efter ditt företag, organisation, projekt eller syfte.",
        "teamNamePlaceholder": "Namn på team",
        "continue": "Skapa team",
        "skip": "Hoppa över",
      },
      // Source: resources/assets/js/lang/pages/onboarding/invite/sv.json
      "invite": {
        "headline": "Bjud in medlemmar",
        "text": "Bjud in dina kollegor att jobba tillsammans. För varje person som accepterar din inbjudan får både ditt team och personen du bjuder in 1 000 krediter att skicka mejl med.",
        "emailPlaceholder": "E-postadress",
        "credits": "Få 1 000 krediter",
        "continue": "Skicka inbjudningar",
        "skip": "Hoppa över",
      },
      // Source: resources/assets/js/lang/pages/onboarding/info/sv.json
      "info": {
        "headline": "Toppen! Nu fortsätter vi.",
        "text": "Berätta mer. Vad heter du och vilket land bor du i?",
        "namePlaceholder": "Ditt namn",
        "countryPlaceholder": "Land där du bor",
        "continue": "Nästa",
      },
      // Source: resources/assets/js/lang/pages/onboarding/errors/sv.json
      "errors": {
        "validation": "Rätta de markerade fälten nedan.",
        "generic": "Något gick fel. Försök igen.",
        "required": "Det här fältet är obligatoriskt.",
      },
    },
    // Source: resources/assets/js/lang/pages/oauth-authorize/sv.json
    "oauth-authorize": {
      "title": "Ge :client tillgång till Minutemailer?",
      "redirect": "När du är klar skickas du tillbaka till :host.",
      "abilities": "Appen kommer att kunna:",
      "readEmails": "Läsa dina utskick, deras innehåll och resultat",
      "readContacts": "Läsa dina kontakter, listor och fält",
      "updateContacts": "Uppdatera kontakter, även deras listor och prenumerationsstatus",
      "manageContacts": "Skapa och hantera kontakter och kontaktlistor",
      "team": "Team",
      "teamDescription": "Appen får bara tillgång till teamet du väljer.",
      "noTeams": "För att ansluta en app behöver du kunna hantera utskick eller kontakter i minst ett team.",
      "approve": "Tillåt",
      "deny": "Neka",
    },
    // Source: resources/assets/js/lang/pages/login/sv.json
    "login": {
      "headline": "Logga in på ditt konto",
      "email_placeholder": "Din e-postadress",
      "email_example": "namn@exempel.se",
      "password_placeholder": "Lösenord",
      "login_submit": "Logga in",
      "forgot_password": "Glömt lösenordet?",
      "no_account": "Har du inget konto?",
      "start_free": "Starta gratis",
      "google_login": "Fortsätt med Google",
      "or_continue_with_email": "Eller",
      "last_used": "Senast använd",
      "social_errors": {
        "failed": "Kunde inte logga in med vald leverantör. Försök igen.",
        "no_email": "Ingen e-postadress returnerades från leverantören.",
        "deleted": "Det kontot har tagits bort och kan inte längre användas för att logga in. Kontakta supporten om du behöver få tillbaka det.",
        "unconfirmed": "Det finns redan ett konto med den här e-postadressen. Logga in med ditt lösenord och koppla sedan Google under Anslutna konton i kontoinställningarna.",
        "blocked": "Vi kunde inte skapa ett konto med den här adressen. Kontakta supporten om du tror att det är fel.",
        "throttled": "För många konton har skapats härifrån. Vänta en stund och försök igen.",
      },
      "activation_expired": "Bekräftelselänken har gått ut eller skickades till en annan adress. Logga in och skicka en ny från dina kontoinställningar.",
    },
    // Source: resources/assets/js/lang/pages/forgot-password/sv.json
    "forgot-password": {
      "headline": "Glömt ditt lösenord?",
      "email_placeholder": "Din e-postadress",
      "email_example": "namn@exempel.se",
      "submit": "Skicka återställningsmejl",
      "login": "Logga in",
      "required": "Fältet är obligatoriskt",
      "success": "Om ett konto med e-postadressen :email finns på Minutemailer så har vi nu skickat en länk för att återställa ditt lösenord.",
    },
    // Source: resources/assets/js/lang/pages/fields/sv.json
    "fields": {
      "title": "Anpassade fält",
      "description": "Med anpassade fält kan du lagra ytterligare information om dina kontakter. Dra för att ordna om fält och använd smarttaggar för att anpassa dina e-postkampanjer. Om du tar bort ett fält kommer all tillhörande data att tas bort permanent.",
      "newField": "Nytt fält",
      "columnFieldName": "Fältnamn",
      "columnFieldType": "Fälttyp",
      "columnVisibility": "Synlighet",
      "columnSmartTag": "Smarttagg",
      "edit": "Redigera",
      "delete": "Ta bort",
      "noFieldsFound": "Inga fält hittades",
      "noFieldsDescription": "Skapa ditt första anpassade fält för att lagra ytterligare kontaktinformation.",
      "public": "Synligt",
      "hidden": "Gömt",
      "fieldDeleted": "Fält borttaget",
      "fieldDeletedDescription": "Fältet och all tillhörande data har tagits bort permanent.",
      "fieldErrortitle": "Misslyckades att spara fält",
      "fieldCreated": "Fält skapat",
      "fieldUpdated": "Fält uppdaterat",
      "confirmDelete": "Är du säker på att du vill ta bort det här fältet?",
      "confirmDeleteDescription": "Detta kommer permanent ta bort fältet och all tillhörande data från dina kontakter. Denna åtgärd kan inte ångras.",
      "confirmDeleteAction": "Ta bort fält",
      "cancel": "Avbryt",
      "typeText": "Text",
      "typeNumeric": "Nummer",
      "typeDate": "Datum",
      "fieldShown": "Visa för prenumeranter",
    },
    // Source: resources/assets/js/lang/pages/external-notifications/sv.json
    "external-notifications": {
      "headline": "Meddelanden",
      "text": "Välj vilka typer av meddelanden du vill få från Minutemailer.",
      "newsletter": "Nyheter, tips och guider via e-post",
      "weeklyStats": "Veckostatistik via e-post",
      "action": "Spara",
      "login": "Logga in",
    },
    // Source: resources/assets/js/lang/pages/dashboard/sv.json
    "dashboard": {
      "dashboardPlainEmail": "Skapa ett vanligt mejl",
      "dashboardDesignEmail": "Skapa ett designat mejl",
      "dashboardDrafts": "Utkast",
      "dashboardScheduled": "Schemalagda",
      "pageTitle": "Skapa ny",
      "menuDelete": "Ta bort",
      "menuDuplicate": "Duplicera",
      "menuEdit": "Redigera",
      "menuCancel": "Avbryt schemaläggning",
      "menuSaveAsTemplate": "Spara som mall",
      "deleteTitle": "Vill du ta bort utkastet?",
      "deleteDescription": "Om du tar bort utkastet kan du inte ångra dig. Är du säker på att du vill ta bort det?",
      "buttonDelete": "Ta bort",
      "buttonCancel": "Avbryt",
      "buttonShowmore": "Visa fler",
      "dashboardStartFromTemplate": "Skapa ny från mall",
      "dashboardAlltemplates": "Visa alla",
      "dashboardLatest": "Senaste",
      "dashboardSaved": "Sparade",
      "dashboardLayout": "Designade",
      "dashboardText": "Bara text",
      "noSavedTemplates": "Välj \"Spara som mall\" när du redigerar ett utkast för att skapa din första mall.",
      "titleLast7Days": "Senaste 7 dagarna",
      "youAreEditingThisEmail": "Du redigerar detta utkast",
      "someoneElseIsEditingThisEmail": ":name redigerar detta utkast",
      "youHaveNoDrafts": "Du har inga utkast",
      "newDraft": "Skapa mejl",
      "tableName": "Namn",
      "tableSubject": "Ämne",
      "tableScheduled": "Schemalagd till",
      "tableSender": "E-post på avsändare",
      "tableLastEdited": "Senast redigerad",
      "cancel": "Avbryt",
      "search": "Sök",
      "sentEmailsTitle": "Skickade mejl",
      "sentEmailsCount": "{0} utskick|{0} utskick",
      "greetingMorning": "God morgon",
      "greetingAfternoon": "God eftermiddag",
      "greetingEvening": "God kväll",
      "buttonCreate": "Skapa mejl",
      "buttonSuggest": "Föreslå mejl",
      "sectionLatest": "Senaste utskick",
      "sectionContinue": "Fortsätt arbeta",
      "sectionScheduled": "Schemalagda",
      "linkViewSendouts": "Visa alla utskick",
      "linkAllDrafts": "Visa alla utkast",
      "linkEdit": "Redigera",
      "sentAt": "Skickat :date",
      "toRecipients": "till :count mottagare",
      "buttonViewReport": "Visa rapport",
      "buttonDuplicate": "Duplicera",
      "opened": "öppnade",
      "clicked": "klickade",
      "bounced": "studsade",
      "untitled": "Namnlös",
      "scheduledFor": "Schemalagd till :date",
      "toastDeleted": "Mejl borttaget",
      "toastDeleteFailed": "Kunde inte ta bort mejlet",
      "tableRecipients": "Mottagare",
      "tableScheduledFor": "Schemalagd till",
      "linkAllScheduled": "Alla schemalagda (:count)",
      "toastCancelled": "Schemalagt mejl avbrutet",
      "toastCancelFailed": "Kunde inte avbryta schemalagt mejl",
      "deleteSelected": "Ta bort markerade",
      "deleteSelectedTitle": "Ta bort :count utkast?",
      "deleteSelectedDescription": "Det här kan inte ångras.",
      "sectionGetStarted": "Kom igång",
      "linkAllTemplates": "Alla mallar",
    },
    "contacts": {
      "tabs": {
        // Source: resources/assets/js/lang/pages/contacts/tabs/unsubscribed/sv.json
        "unsubscribed": {
          "pageTitle": "Avregistrerade",
          "placeholderSearch": "Sök i avregistrerade",
          "emptystateTitle": "Du har inga avregistrerade kontakter i den här listan.",
        },
        // Source: resources/assets/js/lang/pages/contacts/tabs/tabstitles/sv.json
        "tabstitles": {
          "contactsTab": "Kontakter",
          "listsTab": "Listor",
          "pagesTab": "Formulär och sidor",
          "suppressedTab": "Undantagna kontakter",
          "fieldsTab": "Fält",
        },
        // Source: resources/assets/js/lang/pages/contacts/tabs/subscribers/sv.json
        "subscribers": {
          "pageTitle": "Kontakter",
          "buttonImport": "Importera kontakter",
          "buttonExport": "Ladda ned",
          "buttonNewcontact": "Ny kontakt",
          "emptystateTitle": "Din kontaktlista är tom. Lägg till eller importera några kontakter.",
          "placeholderSearch": "Sök i kontakter",
        },
        // Source: resources/assets/js/lang/pages/contacts/tabs/settings/sv.json
        "settings": {
          "pageTitle": "Inställningar för kontaktlistan",
          "listName": "Listans namn",
          "listNameHelp": "Det interna namnet på listan. Ej synligt utanför Minutemailer.",
          "listNamePublicHelp": "Namnet är publikt och syns på mottagarens inställningssida.",
          "listTitle": "Titel på prenumerationssidan",
          "descriptionVisible": "Syns publikt på",
          "descriptionVisibleLink": "listans prenumerationssida",
          "listDescription": "Beskriv vad du får när du prenumererar på listan",
          "textViewinbrowser": "Ändra texten för 'Visa i webbläsare'",
          "textViewinbrowserHelp": "Syns överst i alla designade mejl.",
          "textUnsubscribe": "Ändra texten för 'Avregistrera dig från listan'",
          "textUnsubscribeHelp": "Syns längst ned i alla mejl. Viktigt att det fortfarande framgår att det är en länk för att avregistrera sig.",
          "titleAutoremove": "Automatisk rensning av inaktiva kontakter",
          "descriptionAutoremove": "Ställ in antal utskick innan en inaktiv kontakt blir avregistrerad från listan. Inaktiv betyder att mottagaren inte har öppnat eller klickat på en länk i något av dina utskick. Detta säkerställer att din lista består av aktiva kontakter som vill läsa dina mejl.",
          "publicListLabel": "Publik lista",
          "publicListHelp": "Publika listor är synliga på mottagarens inställningssida så att de kan prenumerera eller avprenumerera från listan.",
          "buttonSave": "Spara",
          "saved": "Inställningar sparade",
          "saveFailed": "Kunde inte spara inställningar",
        },
        // Source: resources/assets/js/lang/pages/contacts/tabs/contacts/sv.json
        "contacts": {
          "tableName": "Namn",
          "tableEmail": "E-post",
          "tableOrigin": "Ursprung",
          "tableCause": "Orsak",
          "tableAdded": "Tillagt",
          "tableContactname": "Kontaktens namn",
          "tableContactemail": "Kontaktens e-post",
          "tableList": "Lista",
          "buttonCancel": "Avbryt",
          "buttonSave": "Spara",
          "menuCopy": "Kopiera",
          "menuMove": "Flytta",
          "menuRestore": "Återställ",
          "menuRemove": "Ta bort",
          "removeTitle": "Vill du ta bort :contacts kontakter?",
          "removeDescription": "Är du säker på att du vill ta bort kontakterna från den här listan? Det går inte att ångra.",
          "buttonRemove": "Ta bort",
          "copyDescription": "Välj en lista att kopiera kontakterna till",
          "buttonCopy": "Kopiera",
          "moveDescription": "Välj en lista att flytta kontakterna till",
          "buttonMove": "Flytta",
          "restoreTitle": "Är du säker på att du vill återställa :contacts kontakter till prenumeranter?",
          "restoreDescription": "Återställer du kontakter till prenumeranter gör det att du kan skicka mejl till dom igen.",
          "buttonRestore": "Återställ",
        },
        // Source: resources/assets/js/lang/pages/contacts/tabs/contact/sv.json
        "contact": {
          "tableContactname": "Kontaktens namn",
          "tableContactemail": "Kontaktens e-post",
          "buttonCancel": "Avbryt",
          "buttonSave": "Spara",
          "menuEdit": "Redigera",
          "menuRemove": "Ta bort",
        },
        // Source: resources/assets/js/lang/pages/contacts/tabs/addtowebsite/sv.json
        "addtowebsite": {
          "pageTitle": "Lägg till webbsajt",
          "pageDescription": "Få fler kontakter genom att lägga till ett formulär på din sajt. Länka till den färdiga prenumerationssidan eller om du behärskar HTML, kopiera och klistra in det färdiga formuläret. Har du en Wordpress-baserad webbsajt kan du också använda vårt Wordpress tillägg.",
          "linkSubscribepage": "Länk till prenumerationssida",
          "linkSubscribepageHelp": "Det enklaste sättet att få nya kontakter",
          "htmlForwebsite": "HTML-kod för formulär",
          "contactListtoken": "Kontaktlistans id",
          "contactListtokenHelp": "Kan användas av externa applikationer och vårt API för att identifiera den här listan.",
          "wordpressTitle": "För Wordpress-baserade sajter",
          "wordpressDescription": "Få fler kontakter genom att lägga till Minutemailer Subscribe tillägget till din Wordpress-sajt eller blogg. Gå till nerladdningssidan eller sök efter 'Minutemailer' bland tillägg i ditt Wordpress gränsnitt.",
          "wordpressButton": "Hämta Wordpress tillägg",
          "formPlaceholderemail": "E-post",
          "formPlaceholdername": "Namn",
          "formButtonsubscribe": "Prenumerera",
        },
      },
      // Source: resources/assets/js/lang/pages/contacts/notifications/sv.json
      "notifications": {
        "contactRemoved": "Kontakten borttagen",
        "contactRemovedContent": "Kontakten :email har tagits bort från din lista",
        "contactsCopied": "Kontakter kopierade",
        "contactsCopiedContent": ":succeeded kontakter kopierades till :list",
        "contactsMoved": "Kontakter flyttade",
        "contactsMovedContent": ":succeeded kontakter flyttades till :list",
        "contactsRestored": "Kontakter återställda",
        "contactsRestoredContent": "De valda kontakterna har återställts till prenumeranter",
      },
      // Source: resources/assets/js/lang/pages/contacts/list/sv.json
      "list": {
        "contactsTitle": "Kontaktlistor",
        "contactslistsNewTitle": "Vad ska listan heta?",
        "contactslistsNewPlaceholder": "Listnamn",
        "contactslistsCreate": "Skapa lista",
        "contactslistsNew": "Ny lista",
        "contactslistsMergeDescription": "Alla kontakter i dessa listor kommer slås ihop till en ny lista med det namn du skriver in nedan. De gamla listorna kommer tas bort.",
        "contactslistsMergeTitle": "Vill du slå ihop kontaktlistorna?",
        "contactslistsMergePlaceholder": "Namn på den nya listan",
        "buttonMerge": "Slå ihop",
        "contactslistsRemoveDescription": "Alla kontakter i den här listan och själva listan kommer tas bort permanent.",
        "contactslistsRemoveTitle": "Vill du ta bort listan?",
        "buttonDelete": "Ta bort",
        "contactsTableListname": "Listnamn",
        "contactsTableContacts": "Kontakter",
        "contactsTableCreated": "Skapad",
        "contactsTablePublic": "Offentlig",
        "contactsTableSubscribers": "Prenumeranter",
        "deleteTitle": "Vill du ta bort listan?",
        "deleteDescription": "Alla kontakter i den här listan och listan kommer tas bort permanent.",
        "buttonCancel": "Avbryt",
        "menuEdit": "Redigera",
        "menuRemove": "Ta bort",
        "menuMerge": "Slå ihop",
        "menuDuplicate": "Duplicera",
        "duplicateTitle": "Duplicera lista",
        "buttonDuplicate": "Duplicera",
        "duplicateDescription": "Alla kontakter i den här listan kommer att kopieras till den nya listan.",
        "duplicateList": "Duplicera",
        "duplicateListPlaceholder": "Nya listans namn",
        "duplicateListName": ":name (Kopia)",
        "contactsClearSearch": "Tillbaka",
        "buttonShowmore": "Visa fler",
        "noLists": "Skapa en kontaktlista.",
        "noListsFound": "Inga kontaktlistor hittades.",
        "buttonImport": "Importera",
        "buttonNewlist": "Ny lista",
        "placeholderSearch": "Sök",
        "contactListAddedTitle": "Lista skapad!",
        "contactListAdded": "En lista har lagts till",
        "contactListsMergedTitle": "Listor ihopslagna!",
        "contactListsMerged": "Listorna har slagits ihop",
        "listDeletedTitle": "Listan är borttagen!",
        "listDeleted": "Listan togs bort",
        "contactListDuplicatedTitle": "Listan duplicerad!",
        "contactListDuplicated": "Listan har duplicerats",
        "foundLists": "Hittade :count lista|Hittade :count listor",
        "columnName": "Listnamn",
        "columnContacts": "Kontakter",
        "columnSubscribers": "Prenumeranter",
        "confirmDeleteLists": "Är du säker på att du vill ta bort de valda listorna? Detta kan inte ångras.",
        "confirmDeleteListsTitle": "Ta bort listor",
        "confirmDeleteListsAction": "Ta bort listor",
        "confirmDeleteList": "Är du säker på att du vill ta bort den här listan? Detta kan inte ångras.",
        "confirmDeleteListTitle": "Ta bort lista",
      },
      // Source: resources/assets/js/lang/pages/contacts/layout/sv.json
      "layout": {
        "search": "Sök",
        "all": "Alla",
        "subscribers": "Prenumeranter",
        "unsubscribed": "Avregistrerade",
        "contactName": "Namn",
        "contactEmail": "E-postadress",
        "contactStatus": "Status",
        "contactOrigin": "Källa",
        "contactUpdated": "Uppdaterad",
        "contactCreated": "Skapad",
        "contactCountry": "Land",
        "contactCity": "Stad",
        "contactPostalCode": "Postnummer",
        "contactAddress": "Adress",
        "contactPhone": "Telefonnummer",
        "actionEmail": "Maila",
        "actionCall": "Ring",
        "actionSMS": "SMS",
        "actionLocation": "Karta",
        "labelFirstname": "Förnamn",
        "labelLastname": "Efternamn",
        "labelEmail": "E-postadress",
        "labelPhone": "Telefonnummer",
        "labelAddress": "Adress",
        "labelPostalCode": "Postnummer",
        "labelCity": "Stad",
        "labelCountry": "Land",
        "placeholderFirstname": "Skriv förnamn",
        "placeholderLastname": "Skriv efternamn",
        "placeholderEmail": "Skriv e-postadress",
        "placeholderPhone": "Skriv telefonnummer",
        "placeholderAddress": "Skriv adress",
        "placeholderPostalCode": "Skriv postnummer",
        "placeholderCity": "Skriv stad",
        "placeholderCountry": "Skriv land",
        "placeholderWritesomething": "Skriv något",
        "tabContacts": "Kontakter",
        "tabSubscribers": "Prenumeranter",
        "tabAddtowebsite": "Få fler prenumeranter",
        "tabSettings": "Inställningar",
        "addtoList": "Lägg till lista",
        "addtoListdescription": "Lägg till :email till vald lista.",
        "addtoMultipleListsdescription": "Lägg till :count kontakt till vald lista.|Lägg till :count kontakter till vald lista.",
        "addtoListbutton": "Lägg till",
        "moveToList": "Flytta till lista",
        "addMoveToListDescription": "Flytta :count kontakt till vald lista.|Flytta :count kontakter till vald lista.",
        "addMoveToListbutton": "Flytta",
        "notSubscribed": "Den här kontakten finns inte på någon lista",
        "listsAddedto": "Tillagd på listor",
        "listsAddedDate": "Datum",
        "remove": "Ta bort",
        "edit": "Ändra",
        "move": "Flytta",
        "noContacts": "Lägg till eller importera din första kontakt.",
        "noSubscribers": "Inga prenumeranter ännu. Lägg till eller importera kontakter för att komma igång.",
        "noUnsubscribed": "Inga avregistrerade kontakter. Alla är fortfarande med!",
        "emptyList": "Inga kontakter i den här listan ännu.",
        "emptyListSubscribers": "Inga prenumeranter i den här listan ännu.",
        "emptyListUnsubscribed": "Inga avregistrerade kontakter i den här listan. Alla är fortfarande med!",
        "labelNotes": "Interna anteckningar",
        "placeholderNotes": "Skriv en anteckning...",
        "displayContacts": "Visa :count kontakt|Visa :count kontakter",
        "foundContacts": "Hittade :count kontakt|Hittade :count kontakter",
        "buttonNewcontact": "Ny kontakt",
        "addContacts": "Lägg till kontakter",
        "buttonImport": "Importera",
        "buttonExport": "Ladda ned .csv",
        "statusSubscribed": "Prenumerant",
        "statusUnsubscribed": "Avregistrerad",
        "statusBlocked": "Blockerad",
        "blockedDescription": "Den här personen har bett Minutemailer att stoppa all e-post till adressen, så hen får inte dina utskick. För att få e-post igen kan hen kontakta Minutemailer på support@minutemailer.com.",
        "noContactsFound": "Inga kontakter hittades",
        "originNoData": "Okänd",
        "originImport": "Importerad",
        "originSubscribed": "Prenumererad",
        "originManuallyAdded": "Manuellt tillagd",
        "originGmail": "Från Gmail",
        "confirmDeleteContacts": "Är du säker på att du vill ta bort kontakterna?",
        "confirmDeleteContactsTitle": "Ta bort kontakter",
        "confirmDeleteContactsAction": "Ta bort kontakter",
        "confirmDeleteContact": "Är du säker på att du vill ta bort den här kontakten?",
        "confirmDeleteContactTitle": "Ta bort kontakt",
        "confirmDeleteContactAction": "Ta bort kontakt",
        "contactsAddedToListTitle": "Kontakt tillagd på lista!",
        "contactsAddedToList": "Kontakten har lagts till vald lista",
        "contactsMovedToListTitle": "Kontakten flyttad till lista!",
        "contactsMovedToList": "Kontakten har flyttats till vald lista",
        "suppressedContacts": ":count undantagen kontakt|:count undantagna kontakter",
        "searchPlaceholder": "Sök",
        "addContact": "Lägg till kontakt",
        "exportCsv": "Exportera som CSV",
        "exportXlsx": "Exportera som XLSX",
        "columnEmail": "E-postadress",
        "columnName": "Namn",
        "columnStatus": "Status",
        "columnOrigin": "Källa",
        "columnCreated": "Skapad",
        "subscriber": "Prenumerant",
        "unsubscribe": "Avregistrera",
        "originManual": "Manuellt tillagd",
        "originImported": "Importerad",
        "originApi": "API",
        "originForm": "Formulär",
        "contactsUnsubscribedTitle": "Kontakter avregistrerade",
        "contactsUnsubscribed": "De valda kontakterna har avregistrerats.",
        "setDate": "Välj datum",
        "resubscribe": "Återprenumerera",
        "buttonSave": "Spara",
        "failedToUpdateEmail": "Kunde inte uppdatera e-postadress",
      },
      // Source: resources/assets/js/lang/pages/contacts/addcontact/sv.json
      "addcontact": {
        "addContact": "Lägg till kontakt",
        "buttonSavecontact": "Spara kontakt",
        "optinText": "Sparar din kontakt utan någon verifiering. Det är ditt ansvar att se till så du har korrekt data och att din kontakt har valt att bli kontaktad av dig.",
        "contactExists": "En kontakt med samma e-postadress existerar redan.",
        "contactExistsAddToList": "En kontakt med samma e-postadress existerar redan. Vill du lägga till kontakten till listan?",
        "contactExistsAddToListAction": "Lägg till i lista",
        "setDate": "Välj datum",
      },
    },
    // Source: resources/assets/js/lang/pages/confirmed-address/sv.json
    "confirmed-address": {
      "headline": "E-postadressen har verifierats",
      "text": "Du kan nu skicka e-post från e-postadressen.",
      "login": "Logga in",
    },
  },
  // Source: resources/assets/js/lang/onboardingLayout/sv.json
  "onboardingLayout": {
    "stepLabel": "Steg :current av :total",
  },
  // Source: resources/assets/js/lang/externalLayout/sv.json
  "externalLayout": {
    "no_account": "Har du inget konto?",
    "start_free": "Starta gratis",
    "already_have_account": "Har du redan ett konto?",
    "login": "Logga in",
    "skip_step": "Du kan göra det här senare",
    "continue": "Fortsätt",
  },
  "dialogs": {
    // Source: resources/assets/js/lang/dialogs/authenticate/sv.json
    "authenticate": {
      "errorAuthenticate": "Misslyckades med att autentisera domänen",
      "content": "Lägg till dessa DNS inställningar för domänen :domain. <a href=\"https://minutemailer.com/authenticate\" target=\"_blank\">Läs denna guide</a>.",
      "titleDialog": "Autentisera din domän",
      "tableStatus": "Status",
      "tableSubdomain": "Subdomän",
      "tableDomain": "Domän",
      "tableType": "Typ",
      "tableValue": "Värde",
      "statusVerified": "Verifierad",
      "statusUnverified": "Ej verifierad",
      "buttonCancel": "Avbryt",
      "buttonClose": "Stäng",
    },
  },
  "config": {
    // Source: resources/assets/js/lang/config/templates/sv.json
    "templates": {
      "empty": "Börja tomt",
      "quick-news": "Snabb nyhet",
      "product-news": "Produktnyheter",
      "newsletter": "Nyhetsbrev",
      "invitation": "Inbjudan",
      "sale": "REA",
      "big-image": "Stor bild",
      "pressrelease": "Pressmeddelande",
      "feedback": "Feedback",
      "big-news": "Stor nyhet",
      "valentines": "Alla hjärtans dag",
      "christmas-card": "Julkort",
      "happy-new-year": "Gott nytt år",
      "new-in-stock": "Nytt i butiken",
      "after-work": "After work",
      "video": "Video",
      "just-image": "Bara bild",
      "just-text": "Bara text",
      "plain_empty": "Börja tomt",
      "plain_sale-soon": "Snart REA",
      "plain_sale": "REA",
      "plain_sale-ends": "Slut på REA",
      "plain_schedule-call": "Boka samtal",
      "plain_quick-update": "Snabb uppdatering",
      "plain_short-reminder": "Kort påminnelse",
      "plain_invite-friend": "Tjäna krediter",
      "plain_free-demo": "Gratis demo",
      "plain_quick-survey": "Snabb undersökning",
      "plain_just-in": "Precis inkommet",
      "plain_moving": "Vi flyttar",
    },
  },
  "components": {
    // Source: resources/assets/js/lang/components/viewemail/sv.json
    "viewemail": {
      "buttonDelete": "Ta bort",
      "buttonDuplicate": "Duplicera",
      "buttonCancelAndEdit": "Avbryt schemaläggning och redigera",
      "buttonResend": "Skicka igen",
      "buttonContactSupport": "Kontakta support",
      "deleteConfirm": "Ta bort",
      "deleteCancel": "Avbryt",
      "deleteTitle": "Är du säker?",
      "tabMobile": "Mobil",
      "tabDesktop": "Desktop",
      "supportMessage": "Mejlet :token misslyckades att skickas. Kan ni ta en titt?",
    },
    // Source: resources/assets/js/lang/components/uploadimage/sv.json
    "uploadimage": {
      "dialogTitle": "Innehåll",
      "buttonUpload": "Ladda upp",
      "buttonDeleteimage": "Ta bort",
      "deleteConfirm": "Ta bort",
      "deleteCancel": "Avbryt",
      "deleteTitle": "Är du säker?",
      "noImages": "Du har inga uppladdade filer",
      "buttonUploadnew": "Ladda upp",
      "chooseImage": "Välj bild",
      "chooseFile": "Välj fil",
      "closeImage": "Stäng",
      "urlTextPlaceholder": "Bildlänk (https://...)",
      "altTextPlaceholder": "Alt text",
      "createEmail": "Skapa mejl från bild",
      "createEmailFromFile": "Skapa mejl från fil",
      "fileLibraryDescription": "Ladda upp den bild eller fil som du vill använda i dina mejl. Välj en JPG, PNG, GIF, PDF, Word, Text eller Excel fil med maxstorlek 128 MB. Om du inte har en bild kan du enkelt skapa en bild utifrån en textbeskrivning med vår AI för bilder.",
      "namePlaceholder": "Bildtitel",
      "createImageDescription": "Behöver du en bild? Beskriv vad du vill ha så skapar vi den åt dig.",
      "generateImage": "Skapa bild",
      "saveGeneratedImage": "Spara bild",
      "closeCreate": "Avbryt",
      "buttonCreate": "Skapa bild",
      "describeImagePlaceholder": "Till exempel: Ett flygande pappersflygplan",
      "describeImageHelp": "Beskriv bilden så detaljerat du kan. Oftast fungerar det bäst att skriva på engelska. Om bilden inte blir som du tänkt testa igen. Det kan ta ca 10 sekunder att skapa en bild.",
      "placeholderSearch": "Sök filer",
      "filesFound": "1 fil|{0} filer",
      "columnName": "Namn",
      "columnType": "Typ",
      "columnSize": "Storlek",
      "columnDate": "Datum",
      "deleteSelected": "Ta bort markerade",
      "deleteSelectedTitle": "Ta bort {count} fil(er)?",
      "deleteSelectedDescription": "Denna åtgärd kan inte ångras.",
      "viewImage": "Visa",
      "buttonDelete": "Ta bort",
      "buttonCancel": "Avbryt",
      "deleteDialogTitle": "Ta bort bild",
      "deleteDialogDescription": "Bilden kommer att tas bort permanent. Denna åtgärd kan inte ångras.",
      "createPreviewPlaceholder": "Din skapade bild visas här",
      "createPreviewGenerating": "Skapar bild...",
      "generateAnother": "Skapa en till",
      "imageGenerating": "Skapar",
      "imageRetry": "Försök igen",
      "imageStarted": "Bildskapande startat",
      "imageCompleted": "Bildskapande klart",
      "imageRemoved": "Bildskapande borttaget",
      "imageGenerationFailed": "Bildskapandet misslyckades. Försök att omformulera din beskrivning.",
      "selectImage": "Välj bild",
    },
    // Source: resources/assets/js/lang/components/updatecard/sv.json
    "updatecard": {
      "dialogTitle": "Uppdatera kort",
      "nameNeeded": "Namn behöver vara ifyllt",
      "nameCard": "Namn på kortet",
      "buttonCancel": "Avbryt",
      "buttonUpdate": "Uppdatera",
    },
    // Source: resources/assets/js/lang/components/typefaceselect/sv.json
    "typefaceselect": {
      "selectWebsafe": "Webbsäkra typsnitt",
      "selectGoogle": "Webbtypsnitt från Google",
    },
    // Source: resources/assets/js/lang/components/todos/sv.json
    "todos": {
      "titleTodo": "Att göra",
      "buttonNewtodo": "Skapa uppgift",
      "buttonTryagain": "Försök igen",
      "errorCouldntload": "Vi kunde inte ladda in din att göra lista. Försök igen.",
      "notificationTitletodoadded": "Uppgift tillagd",
      "notificationTexttodoadded": "Du har skapat en uppgift!",
      "notificationTitletodonotadded": "Uppgift ej tillagd",
      "notificationTexttodonotadded": "Vi kunde inte lägga till din uppgift. Försök igen.",
      "placeholderTodo": "Vad vill du få gjort?",
      "buttonCancel": "Avbryt",
      "buttonSave": "Spara",
      "notificationTitletododone": "Uppgiften är avklarad!",
      "notificationTexttododone": "Du avslutade en uppgift. Bra jobbat!",
      "errorTitletododone": "Misslyckades att sätta till avklarad",
      "errorTexttododone": "Vi kunde inte sätta din uppgift till avklarad. Försök igen.",
      "notificationTitletodoupdated": "Din att göra lista har uppdaterats",
      "notificationTexttodoupdated": "Nu en ännu bättre att göra lista!",
      "errorTitletodoupdated": "Kunde inte uppdatera din att göra lista",
      "errorTexttodoupdated": "Vi kunde inte uppdatera din att göra lista. Försök igen!",
      "errorTitletododeleted": "Misslyckades att ta bort uppgift",
      "notificationTitletododeleted": "Uppgift borttagen",
      "notificationTexttododeleted": "Du tog bort en uppgift från listan. Skönt!",
      "buttonShowall": "Visa alla",
      "buttonShowless": "Visa färre",
      "emptyState": "Inga uppgifter just nu",
      "reward": "Få {0} krediter",
    },
    // Source: resources/assets/js/lang/components/templatechooser/sv.json
    "templatechooser": {
      "dialogTitle": "Skapa nytt mejl",
      "templatechooserAll": "Alla",
      "templatechooserSaved": "Sparade",
      "templatechooserLayout": "Designade",
      "templatechooserText": "Bara text",
      "templatechooserAI": "Föreslå mejl",
      "premiumTemplates": "Premium-mallar",
      "templatechooserShowMore": "Visa fler",
      "templatesTitleNew": "Skapa ny från mall",
      "templatechooserNoTemplates": "Skapa ett nytt mejl och spara som mall.",
      "templatechooserCreate": "Skapa",
    },
    // Source: resources/assets/js/lang/components/teamsettings/sv.json
    "teamsettings": {
      "companyTeamSettingsTitle": "Team-inställningar",
      "companyTeamSettingsDescription": "Inställningar för ditt team. Visas ej publikt.",
      "teamNamePlaceholder": "Döp ditt team",
      "teamBillingEmailPlaceholder": "E-postadress för betalningar",
      "teamEmailPlaceholder": "E-postadress för teamet",
      "teamLang": "Språk",
      "teamAvatarLabel": "Teamets bild",
      "teamAvatarUpload": "Ladda upp en bild",
      "teamAvatarFavicon": "Hemsidans ikon",
      "teamAvatarInitials": "Initialer",
      "teamAvatarSave": "Spara",
      "teamAvatarCancel": "Avbryt",
    },
    // Source: resources/assets/js/lang/components/tag/sv.json
    "tag": {
      "mostPopular": "Populärast",
      "bestValue": "Mest värde",
    },
    // Source: resources/assets/js/lang/components/sending/sv.json
    "sending": {
      "contacts": "{0} kontakter",
    },
    // Source: resources/assets/js/lang/components/paywall/sv.json
    "paywall": {
      "title": "Lås upp mer med PRO",
      "upgradeToUnlock": "Alla betalplaner inkluderar:",
      "moreCredits": "Fler krediter per månad att skicka mejl med",
      "unlimitedStats": "Obegränsad historik och team-medlemmar",
      "aiFeatures": "AI funktioner: Föreslå mejl, text, bild och ämnesrad",
      "uploadFiles": "Ladda upp och skicka filer",
      "premiumTemplates": "Prioriterad support",
      "upgradePlan": "Uppgradera kontot",
      "noPermissions": "Du behöver tillgång till betalningar för att uppgradera",
      "removePromoLink": "Skicka mejl utan Minutemailer-länk",
      "customFonts": "Ladda upp egna typsnitt",
      "prioritySupport": "Prioriterad support",
    },
    // Source: resources/assets/js/lang/components/password-input/sv.json
    "password-input": {
      "show": "Visa lösenord",
      "hide": "Dölj lösenord",
    },
    // Source: resources/assets/js/lang/components/pagination/sv.json
    "pagination": {
      "previous": "Föregående",
      "next": "Nästa",
    },
    // Source: resources/assets/js/lang/components/invite/sv.json
    "invite": {
      "title": "Bjud in medlemmar",
      "text": "Bjud in dina kollegor till Minutemailer. För varje person som godkänner din inbjudan får både ditt team och medlemmen 1 000 gratis krediter att skicka e-post med. Be inbjudna medlemmar att kolla sin inbox och skräpkorg efter inbjudan.",
      "placeholderEmail": "E-postadress",
      "buttonCancel": "Avbryt",
      "buttonInvite": "Skicka inbjudan",
      "someInvitationsSentTitle": "Inbjudan skickad",
      "someInvitationsSentText": "Skickade inbjudan till ditt team. En eller flera e-postadresser är redan inbjudna.",
      "invitationsSentTitle": "Inbjudan skickad",
      "invitationsSentText": "Skickade inbjudan till ditt team.",
      "noInvitationsSentTitle": "Ingen inbjudan skickad",
      "noInvitationsSentText": "En eller flera e-postadresser är redan inbjudna.",
      "limitReached": "Du försökte bjuda in :new men har redan :current medlemmar och väntande inbjudningar. Uppgradera kontot för att bjuda in fler än :limit medlemmar till det här teamet.",
    },
    // Source: resources/assets/js/lang/components/import/sv.json
    "import": {
      "placeholderImport": "Klistra in dina e-postadresser här och klicka på importera...",
      "buttonImport": "Importera",
      "titleSelect": "Välj vilka fält du vill importera",
      "labelEmail": "E-postadress",
      "labelName": "Namn?",
      "buttonImportcontacts": "Importera",
      "buttonCancel": "Avbryt",
      "titleImport": "Importera dina kontakter",
      "descriptionImport": "Välj en Excel eller CSV fil att importera. CSV filer bör ha UTF-8 format för att importeras korrekt. Du kan också klistra in kontakter direkt i textfältet nedanför.",
      "warningImport": "Se till så dina kontakter har valt att få dina utskick annars riskerar dina mejl hamna i skräpkorgen. Om du är osäker på om de valt att få dina utskick bör du undvika att importera kontakterna.",
      "buttonUpload": "Välj en fil",
      "buttonGoogle": "Importera från Google Contacts (Gmail)",
      "progressImporting": "Importerar kontakter...",
      "progressContacts": "{1} / {0} kontakter",
      "titlePasteImport": "Eller lägg till direkt nedan",
      "fieldUnassigned": "Ej tilldelad",
      "newField": "Skapa nytt fält",
      "fieldFirstName": "Förnamn",
      "fieldLastName": "Efternamn",
      "fieldPhone": "Telefonnummer",
      "fieldAddress": "Adress",
      "fieldPostalCode": "Postnummer",
      "fieldCity": "Stad",
      "fieldCountry": "Land",
      "modeFillEmpty": "Fyll enbart tomma",
      "modeReplace": "Ersätt innehåll",
      "titleSelectLists": "Välj listor att importera till",
      "tableListName": "Namn på lista",
      "tableListContacts": "Kontakter i listan",
      "buttonSelectListsNext": "Fortsätt",
      "titleSelectSheet": "Välj ark att importera",
      "errorSelectsheet": "Något gick fel när du skulle välja ark att importera. Försök igen eller kontakta vår support.",
      "selectSheet": "Välj ark",
      "saveSheetSelection": "Välj ark",
      "importStartedTitle": "Importerar kontakter från \":name\"",
      "importStartedText": "Vi lägger till kontakter till din adressbok.",
      "importingContactsStatus": "Importerar kontakter – :percent% färdigt",
      "importStartedNotificationTitle": "Import startad",
      "importStartedNotificationContent": "Dina kontakter importeras till din adressbok.",
      "importCompletedNotificationTitle": "Importen färdig",
      "importCompletedNotificationContent": "Dina kontakter har importerats till din adressbok.",
      "textImportedNotificationTitle": "Importen färdig",
      "textImportedNotificationContent": "Dina kontakter har importerats till din adressbok.",
      "errorImport": "Något gick fel med importen. Vänligen försök igen.",
      "errorLoadLists": "Vi kunde inte ladda dina listor. Försök igen.",
      "buttonRetryLists": "Försök igen",
    },
    // Source: resources/assets/js/lang/components/error/sv.json
    "error": {
      "messageError": "Något har gått fel. Försök gärna igen. Om problemet fortsätter kontakta vår support och beskriv ditt problem så detaljerat som möjligt så hjälper vi dig så snart vi kan.",
    },
    // Source: resources/assets/js/lang/components/emailgenerator/sv.json
    "emailgenerator": {
      "purposeLabel": "Vad är syftet eller målet med ditt mejl?",
      "aboutLabel": "Beskriv mer i detalj vad det här mejlet handlar om:",
      "aboutPlaceholder": "Beskriv vad ditt mejl handlar om",
      "designedEmailOption": "Designat nyhetsbrev med layout",
      "textEmailOption": "Vanligt textmejl utan bilder",
      "submit": "Skapa mejl",
      "completeBusinessInfoHeadline": "Fyll i information om din verksamhet",
      "completeBusinessInfoBody": "Du behöver berätta mer om din verksamhet så att vi kan hjälpa dig med att föreslå innehåll.",
      "completeBusinessInfo": "Uppdatera dina inställningar",
      "purposeRequired": "Vänligen välj ett syfte för ditt mejl",
      "aboutRequired": "Vänligen beskriv vad ditt mejl handlar om",
    },
    // Source: resources/assets/js/lang/components/email-list/sv.json
    "email-list": {
      "menuDelete": "Ta bort",
      "menuDuplicate": "Duplicera",
      "menuEdit": "Redigera",
      "menuCancel": "Avbryt schemaläggning",
      "menuSaveAsTemplate": "Spara som mall",
      "deleteTitle": "Vill du ta bort utkastet?",
      "deleteDescription": "Om du tar bort utkastet kan du inte ångra dig. Är du säker på att du vill ta bort det?",
      "buttonDelete": "Ta bort",
      "buttonCancel": "Avbryt",
      "buttonShowmore": "Visa fler",
      "dashboardStartFromTemplate": "Skapa ny från mall",
      "youAreEditingThisEmail": "Du redigerar detta utkast",
      "someoneElseIsEditingThisEmail": ":name redigerar detta utkast",
      "youHaveNoDrafts": "Du har inga utkast",
      "youHaveNoSent": "Du har inte skickat något",
      "newDraft": "Skapa mejl",
      "tableName": "Namn på utkast",
      "tableSubject": "Ämne",
      "tableScheduled": "Schemalagd till",
      "tableSender": "E-post på avsändare",
      "tableLastEdited": "Senast redigerad",
      "tableWhen": "När",
      "tableTo": "Till",
      "cancel": "Avbryt",
      "search": "Sök",
      "sentEmailsCount": "{0} utskick|{0} utskick",
      "sentTo": "{0} kontakt|{0} kontakter",
      "somethingWentWrong": "Tillfälligt fel. Vänligen försök igen om en stund.",
      "limitedStatsMessage": "Uppgradera din plan för att se utskick äldre än 30 dagar.",
      "tryAgain": "Försök igen",
      "untitled": "Utkast",
      "suggestEmail": "Föreslå mejl",
    },
    // Source: resources/assets/js/lang/components/email-data/sv.json
    "email-data": {
      "emailFrom": "Från",
      "emailTo": "Till",
      "emailSubject": "Ämne",
      "emailWhen": "När",
      "allContacts": "Alla kontakter",
      "optimizedSendTime": "Skickat över 24 timmar för bättre leverans",
    },
    "editor": {
      // Source: resources/assets/js/lang/components/editor/testandsend/sv.json
      "testandsend": {
        "dialogTitle": "Skicka",
        "dialogTitleSchedule": "Schemalägg",
        "dialogHelp": "Kontrollera ditt mejl en sista gång. Se till så du inte har några stavfel och att ditt mejl ser bra ut både på mobilen och desktop.",
        "dialogTitleTemplate": "Förhandsvisa mall",
        "dialogHelpTemplate": "Kontrollera att din mall ser bra ut både på desktop och i mobilen innan du sparar den och använder den för dina utskick.",
        "dialogClose": "Stäng förhandsvisning",
        "buttonSend": "Skicka till {0} kontakt|Skicka till {0} kontakter",
        "buttonSchedule": "Schemalägg till {0} kontakt|Schemalägg till {0} kontakter",
        "buttonCancel": "Avbryt",
        "buttonSaveAsTemplate": "Spara som mall",
        "buttonBuyCredits": "Köp krediter",
        "credits": "Få 1 000 krediter",
        "tabMobile": "Mobil",
        "tabDesktop": "Desktop",
        "sendPreviewTitle": "Skicka förhandsvisning",
        "sendPreviewSubTitle": "(max 5 mottagare, kommaseparerade)",
        "inviteTeam": "Bjud in medlemmar",
        "sendPreviewButton": "Skicka",
        "sendPreviewInputPlaceholder": "En eller flera e-postadresser",
        "sentPreviewNotificationTitle": "Förhandsvisning skickad!",
        "sentPreviewNotificationContent": "Din förhandsvisning har skickats till :email",
        "noContactsWarning": "Du behöver välja åtminstone en kontakt för att kunna skicka eller schemalägga.",
        "unauthenticatedError": "Din e-postdomän är inte autentiserad. Autentisera den eller använd våra färdiga e-postadresser.",
        "authenticateDomainLinkText": "Läs mer om autentisering av domäner",
        "authenticateDomainLinkUrl": "https://www.minutemailer.com/sv/guides/authenticate/",
        "emailSettings": "E-postinställningar",
        "tooManyPreviewsSent": "Du har skickat för många förhandsvisningar. Vänta en stund och pröva igen.",
        "sendOverTime": "Skicka mejlet över tid (max 24 timmar) för bättre leverans.",
        "contactSupport": "Kontakta supporten",
        "yourAccountIsPaused": "Ditt konto har inaktiverats på grund av aktiviteter som bryter mot våra användarvillkor. Kontakta vår support för att återaktivera det.",
        "maxRecipientsMessage": "Du kan bara välja {0} mottagare",
      },
      // Source: resources/assets/js/lang/components/editor/popup/sv.json
      "popup": {
        "backdropPanelTitle": "Bakgrundslager",
        "backdropColorHelp": "Färg på lagret bakom popupen",
        "backdropOpacityHelp": "Opacitet",
        "backdropBlurHelp": "Oskärpa på sidan bakom popupen",
        "popupPanelTitle": "Popup",
        "shadowHelp": "Skugga",
        "shadowNone": "Ingen skugga",
        "shadowSmall": "Liten",
        "shadowMedium": "Mellan",
        "shadowLarge": "Stor",
        "shadowXlarge": "Extra stor",
        "closeColorHelp": "Färg på stängknappen",
        "transitionPanelTitle": "Övergång",
        "transitionHelp": "Hur popupen visas",
        "transitionNone": "Ingen",
        "transitionFade": "Tona in",
        "transitionSlideUp": "Glid upp",
        "transitionSlideDown": "Glid ner",
        "transitionGrow": "Väx",
        "transitionShrink": "Krymp",
        "transitionFlip": "Vänd",
        "easingHelp": "Rörelse",
        "easingSmooth": "Mjuk",
        "easingEaseInOut": "Mjuk start och slut",
        "easingOvershoot": "Överskjut",
        "easingSpring": "Fjäder",
        "easingBounce": "Studs",
        "durationHelp": "Längd",
        "play": "Spela upp",
        "close": "Stäng",
      },
      // Source: resources/assets/js/lang/components/editor/layout/sv.json
      "layout": {
        "sidebarAdd": "Nytt",
        "sidebarEdit": "Ändra",
        "sidebarDesign": "Design",
        "imageAlthelp": "Alternativ beskrivning om e-postklienten inte ladda in bilder och för skärmläsare",
        "removeImage": "Ta bort bild",
        "imageTitle": "Bild",
        "imageDescription": "Beskrivning",
        "imagePanelDesign": "Design",
        "contentPanelTitle": "Innehåll",
        "backgroundPanelTitle": "Bakgrund",
        "backgroundContenthelp": "Innehållsfärg",
        "backgroundColorhelp": "Bakgrundsfärg",
        "dividerTitle": "Design",
        "dividerStyle": "Typ",
        "dividerLength": "Längd",
        "dividerThickness": "Tjocklek",
        "placeholderLink": "Länk",
        "linkTitle": "Länktitel",
        "addLink": "Lägg till länk",
        "buttonUnlink": "Ta bort länk",
        "fontWeight": "Teckenvikt",
        "fontWeightThin": "Tunn",
        "fontWeightExtraLight": "Extra tunn",
        "fontWeightLight": "Lätt",
        "fontWeightNormal": "Normal",
        "fontWeightMedium": "Medium",
        "fontWeightSemiBold": "Halvfet",
        "fontWeightBold": "Fet",
        "fontWeightExtraBold": "Extrafet",
        "fontWeightBlack": "Svart",
        "fontWeightThinItalic": "Tunn kursiv",
        "fontWeightExtraLightItalic": "Extra tunn kursiv",
        "fontWeightLightItalic": "Lätt kursiv",
        "fontWeightNormalItalic": "Normal kursiv",
        "fontWeightMediumItalic": "Medium kursiv",
        "fontWeightSemiBoldItalic": "Halvfet kursiv",
        "fontWeightBoldItalic": "Fet kursiv",
        "fontWeightExtraBoldItalic": "Extrafet kursiv",
        "fontWeightBlackItalic": "Svart kursiv",
        "insert": "Infoga",
        "imageRotate": "Rotera",
        "imageFlipHorizontal": "Vänd horisontellt",
        "imageFlipVertical": "Vänd vertikalt",
        "buttonPanelButton": "Knappinställningar",
        "buttonPanelDesign": "Design",
        "buttonPanelTitle": "Knappar",
        "dividersPanelTitle": "Avdelare",
        "buttonAlignment": "Placering",
        "buttonSize": "Storlek",
        "buttonStyle": "Stil",
        "buttonShape": "Form",
        "buttonPlaceholder": "Knapptext",
        "nologoHelp": "Ingen logotyp än. Den delas i alla dina mejl.",
        "nologo": "Lägg till logo",
        "nologoHint": "Anges i designinställningarna.",
        "nologoButton": "Gå till dina inställningar",
        "editLogoButton": "Ändra logo",
        "logoPanelDesign": "Logotyp",
        "logoAlignment": "Placering",
        "textPaneltext": "Text",
        "textPanelParagraph": "Paragraf",
        "textPanelMergeTags": "Infoga",
        "textPanelLinking": "Länk",
        "textColorhelp": "Textfärg",
        "textMigrateTitle": "Uppdatera textblock",
        "textMigrateBody": "Det finns ett nytt och förbättrat textblock. Uppdateringen kan i vissa fall leda till förlust av formatering eller innehåll.",
        "textMigrateButton": "Uppdatera blocket",
        "linkColorhelp": "Länkfärg",
        "chooseFont": "Välj typsnitt",
        "textPlaceholder": "Skriv något...",
        "signature": "Skickat med Minutemailer",
        "buttonCancel": "Avbryt",
        "breakpointEditingBase": "Redigerar bas",
        "breakpointEditingFor": "Redigerar för :breakpoint",
        "buttonEdit": "Redigera adresser",
        "linkTypeWebsite": "Webbsajt (http://)",
        "linkTypeWebsiteS": "Webbsajt (https://)",
        "linkTypeEmail": "E-post (mailto:)",
        "linkTypeSms": "SMS (sms:)",
        "linkTypePhone": "Telefon (tel:)",
        "sectionColumns": "1 kolumn|:columns kolumner",
        "selectAnAddress": "Välj en adress",
        "errorMessage": "Något gick fel. Pröva gärna igen.",
        "componentError": "Det här innehållsblocket kan inte redigeras på grund av ett fel. Du kan fortfarande ta bort det. Kontakta supporten för mer information.",
        "sectionError": "Den här sektionen kan inte redigeras på grund av ett fel. Du kan fortfarande ta bort den. Kontakta supporten för mer information.",
        "editorError": "Något gick fel i editorn. Resten av sidan är fortfarande tillgänglig. Kontakta supporten för mer information.",
        "contactSupport": "Kontakta supporten",
        "errorContentTooShort": "Ditt mejl behöver mer innehåll innan vi kan föreslå ämnesrader. Lägg till mer text och försök igen.",
        "titleSubject": "Välj en ämnesrad",
        "buttonReload": "Ladda om",
        "clickToedit": "Klicka på en sektion eller komponent för att redigera den",
        "editorLockedTitle": "Låst",
        "editorLockedDescription": "Det här objektet är låst och kan inte redigeras.",
        "segmentDesign": "Design",
        "segmentExtrapadding": "Extra marginal",
        "segmentExtrahelpabove": "Ovanför första sektionen",
        "segmentExtrahelpbelow": "Nedanför sista sektionen",
        "marginTitle": "Marginal",
        "marginAbove": "Ovanför",
        "marginBelow": "Nedanför",
        "marginLeft": "Till vänster",
        "marginRight": "Till höger",
        "titleLinks": "Länkar",
        "iconColor": "Färg",
        "iconShape": "Form",
        "addLinkshelp": "Lägg till länkar i sidopanelen",
        "clickToadd": "Klicka för att lägga till länkar",
        "addImage": "Välj bild",
        "imageSize": "Storlek på bild",
        "imageRepeat": "Upprepning av bild",
        "imagePosition": "Placering av bild",
        "switchFullwidth": "Full bredd",
        "switchTransparent": "Transparent bakgrund",
        "oneColumn": "En kolumn",
        "twoColumn": "Två kolumner",
        "threeColumns": "Tre kolumner",
        "fourColumns": "Fyra kolumner",
        "componentText": "Text",
        "componentButton": "Knapp",
        "componentImage": "Bild",
        "componentLink": "Länk",
        "componentDivider": "Avdelare",
        "componentLogo": "Logo",
        "titleLayout": "Layout",
        "titleContent": "Innehåll",
        "addContent": "Lägg till innehåll",
        "titleSections": "Sektioner",
        "confirmDeleteSectionText": "Sektionen och allt dess innehåll kommer tas bort. Detta kan ej ångras.",
        "confirmDeleteSectionTitle": "Vill du ta bort sektionen?",
        "confirmDeleteSectionButton": "Ta bort",
        "confirmDeleteComponentText": "Är du säker på att du vill ta bort innehållet? Detta kan ej ångras.",
        "confirmDeleteComponentTitle": "Vill du ta bort innehållet?",
        "confirmDeleteComponentButton": "Ta bort",
        "toAllcontacts": "Alla kontakter",
        "toAllnewsincelast": "Alla nya sedan förra utskicket",
        "toAllwhoopened": "Alla som öppnade förra utskicket",
        "toAllwhoclicked": "Alla som klickade på förra utskicket",
        "toAllwhonotopened": "Alla som inte öppnade förra utskicket",
        "toAllwhonotclicked": "Alla som inte klickade på förra utskicket",
        "noSections": "Placera layout här för att kunna lägga till innehåll",
        "feedbackHelp": "Dina kontakter kommer kunna ge feedback på ditt mejl. Lägg bara till en rubrik för att beskriva vad de ger feedback på. Resultatet kommer synas på din resultatsida för mejlet efter att det har skickats.",
        "feedbackPanelSetting": "Design",
        "alignmentPanelTitle": "Justering",
        "contentPanelHeader": "Inställningar för sidhuvud",
        "contentViewInBrowserHelp": "Text för visa i webbläsare",
        "contentPanelFooter": "Inställningar för sidfot",
        "contentUnsubscribeTextHelp": "Text för avregistrering",
        "viewInBrowserPlaceholder": "Visa i webbläsare",
        "unsubscribeTextPlaceholder": "Avregistrera från listan",
        "chooseVideo": "Välj video",
        "videoEditorTitle": "Välj en video",
        "videoUrl": "Videolänk",
        "videoUrlPlaceholder": "Video url",
        "videoUrlHelp": "Klistra in en länk till valfri video. Endast videor från Youtube kommer hämta tumnageln automatiskt.",
        "videoEditorCancel": "Avbryt",
        "videoEditorSave": "Spara",
        "videoPanelUrl": "Video",
        "videoPanelCustomImage": "Anpassad tumnagel",
        "videoAddCustomImage": "Lägg till tumnagel",
        "videoStyleHelp": "Välj uppspelningssymbol",
        "feedbackTypeLike": "Gilla",
        "feedbackTypeNPS": "NPS",
        "feedbackTypeRating": "Betyg",
        "feedbackType": "Typ",
        "Text": "Text",
        "Button": "Knapp",
        "Image": "Bild",
        "Video": "Video",
        "Social": "Socialt",
        "Divider": "Avdelare",
        "Logo": "Logotyp",
        "Feedback": "Feedback",
        "File": "Fil",
        "Form": "Formulär",
        "Spacing": "Mellanrum",
        "One column": "En kolumn",
        "Two columns": "Två kolumner",
        "Three columns": "Tre kolumner",
        "Four columns": "Fyra kolumner",
        "2+1 columns": "2+1 kolumner",
        "1+2 columns": "1+2 kolumner",
        "3+1 columns": "3+1 kolumner",
        "1+3 columns": "1+3 kolumner",
        "unauthenticated": "Ej autentiserad",
        "fromName": "Avsändarnamn",
        "fromEmail": "Avsändaradress",
        "contentWidthHelp": "Bredd på innehåll",
        "maxContentWidthHelp": "Maxbredd på innehåll",
        "errorNodraftmessage": "Det begärda utkastet finns inte. Du skickas till hemskärmen.",
        "errorNodrafttitle": "Utkastet finns inte",
        "errorUnexpectedmessage": "Något oväntat hände. Var god försök igen.",
        "errorUnexpectedtitle": "Kunde inte spara",
        "errorEmaillockedbyyou": "Utkastet är låst av dig själv i en annan flik. Hitta fliken för att undvika dataförlust eller ta över redigeringen i den här fliken.",
        "errorEmaillockedbysomeone": "Detta utkast är låst av :name. För att göra ändringar måste du ta över redigeringen av utkastet. Detta kommer att låsa ute den nuvarande redigeraren med möjlig dataförlust.",
        "errorEmailtakenbyyou": "Utkastet har tagits över av dig själv i en annan flik. Hitta den fliken för att undvika dataförlust eller ta över redigeringen i den här fliken.",
        "errorEmailtakenbysomeone": "Utkastet har tagits över av :name. För att göra ändringar måste du ta över redigeringen av utkastet. Detta kommer att låsa ute den nuvarande redigeraren med möjlig dataförlust.",
        "draftLockedtitle": "Låst utkast",
        "buttonTakeover": "Ta över utkast",
        "buttonLeave": "Lämna utkast",
        "sessionExpiredtitle": "Fortsätt redigera?",
        "fetchingSubjects": "Skapar förslag på ämnesrader baserat på ditt innehåll...",
        "fileUploadSettings": "Filinställningar",
        "fileUploadButton": "Välj fil",
        "downloadButtonText": "Ladda ned",
        "fileRemoveButton": "Ta bort",
        "spacingHeightHelp": "Ställ in höjden på utrymmet.",
        "preheaderPlaceholder": "Kort summering av mejlets innehåll",
        "footerCompanyInfoPlaceholder": "Företagsinfo",
        "spacingTitle": "Mellanrum",
        "sameMargin": "Samma marginal",
        "marginAllSides": "Alla sidor",
        "socialDesign": "Design",
        "socialSpacingLabel": "Mellanrum",
        "borderTitle": "Ram",
        "borderRadius": "Rundade hörn. Fungerar inte i vissa e-postklienter.",
        "borderRadiusWeb": "Rundade hörn.",
        "buttonFullWidth": "Full bredd",
        "segmentMobile": "Mobilinställningar",
        "sectionMobileHelp": "Inställningar för hur sektionen visas på mindre skärmar. Fungerar inte i alla e-postklienter.",
        "hideOnMobile": "Dölj på mobil",
        "hideOnMobileHelp": "Göm sektion.",
        "wrapOnMobile": "En kolumn",
        "wrapOnMobileHelp": "Kolumner kommer staplas ovanpå varandra.",
        "sectionPanel": "Sektion",
        "sectionNamePlaceholder": "Sektionsnamn",
        "sectionNameHelp": "Döp sektionen för kunna hoppa direkt till den från en text eller knapp.",
        "showViewInBrowser": "Visa i webbläsare",
        "contentShowViewInBrowserHelp": "Visa en länk för att öppna mejlet i en webbläsare.",
        "preTextPlaceholder": "En kort beskrivning av mejlet",
        "contentPreTextHelp": "En kort beskrivning som visas i e-postklienter tillsammans med ämnesraden.",
        "showPreText": "Visa förtext",
        "contentShowPreTextHelp": "Visa en kort sammanfattning av mejlets innehåll.",
        "headerLayoutCentered": "Centrerad layout",
        "contentHeaderLayoutCenteredHelp": "Centrera innehållet i sidhuvudet.",
        "hideFooterText": "Dölj sidfotstext",
        "contentHideFooterTextHelp": "Dölj sidfotstexten.",
        "footerLayoutCentered": "Centrerad layout",
        "contentFooterLayoutCenteredHelp": "Centrera innehållet i sidfoten.",
        "border": "Ram",
        "columnsPanel": "Kolumner",
        "gridGapHelp": "Mellanrum mellan kolumner",
        "verticalAlignment": "Vertikal kolumnplacering",
        "badgeDesign": "Minutemailerlänk",
        "badgeColorLight": "Ljus",
        "badgeColorDark": "Mörk",
        "badgeStyle_explanation": "Lång text",
        "badgeStyle_text": "Kort text",
        "badgeStyle_minutemailer": "Logotyp",
        "badgeStyle": "Stil",
        "badgeColor": "Färg",
        "referralInfoText": "Få fler krediter när någon registrerar sig på Minutemailer med din länk. Välj design och placering.",
        "referralPromoInfoText": "Få fler krediter när någon registrerar sig på Minutemailer med din länk. Uppgradera ditt team för att ta bort länken.",
        "upgrade": "Uppgradera",
        "dropHere": "Släpp här",
        "addImageButton": "Lägg till bild",
        "imageActionAutoCreate": "Skapa från innehållet",
        "imageActionCreate": "Skapa egen bild",
        "imageActionUpload": "Ladda upp",
        "imageActionChoose": "Välj bild",
        "backgroundImageLabel": "Bakgrundsbild",
        "bgSizeOriginal": "Original",
        "bgSizeCover": "Heltäckande",
        "bgRepeat": "Upprepa",
        "bgNoRepeat": "Ingen upprepning",
        "bgRepeatHorizontal": "Upprepa horisontellt",
        "bgRepeatVertical": "Upprepa vertikalt",
        "bgPosLeftTop": "Vänster uppe",
        "bgPosCenterTop": "Mitten uppe",
        "bgPosRightTop": "Höger uppe",
        "bgPosLeftCenter": "Vänster mitten",
        "bgPosCenter": "Mitten",
        "bgPosRightCenter": "Höger mitten",
        "bgPosLeftBottom": "Vänster nere",
        "bgPosCenterBottom": "Mitten nere",
        "bgPosRightBottom": "Höger nere",
        "videoNotSupported": "Den videolänken stöds inte. Klistra in en YouTube- eller Vimeo-adress.",
        "toggleEditorSidebar": "Visa eller dölj redigeringspanelen",
      },
      // Source: resources/assets/js/lang/components/editor/form/sv.json
      "form": {
        "includedFields": "Inkluderade fält",
        "addField": "Lägg till fält",
        "searchFields": "Sök fält",
        "noFields": "Inga fält hittades",
        "standardFields": "Standardfält",
        "customFields": "Egna fält",
        "loadingFields": "Laddar egna fält…",
        "loadFieldsFailed": "Kunde inte ladda egna fält.",
        "retry": "Försök igen",
        "reorderField": "Ändra ordning på :name",
        "removeField": "Ta bort :name",
        "backToForm": "Tillbaka till formuläret",
        "inputSettings": "Fältinställningar",
        "contactField": "Kontaktfält: :name",
        "label": "Etikett",
        "placeholder": "Platshållare",
        "required": "Obligatoriskt",
      },
    },
    // Source: resources/assets/js/lang/components/credits-button/sv.json
    "credits-button": {
      "credits": "{0} kredit|{0} krediter",
    },
    // Source: resources/assets/js/lang/components/credits/sv.json
    "credits": {
      "buttonAdd": "Lägg till",
    },
    // Source: resources/assets/js/lang/components/createfield/sv.json
    "createfield": {
      "title": "Skapa nytt fält",
      "fieldName": "Namn på fält",
      "text": "Text",
      "number": "Nummer",
      "date": "Datum",
      "fieldShown": "Visa för prenumeranter",
      "buttonCancel": "Avbryt",
      "buttonCreate": "Skapa fält",
    },
    // Source: resources/assets/js/lang/components/createList/sv.json
    "createList": {
      "title": "Döp listan",
      "body": "Gör listan publik för att visa den som ett alternativ vid avregistrering från sidfoten i ett mejl.",
      "placeholder": "Listnamn",
      "public": "Publik lista",
      "nameHelp": "Det interna namnet på listan.",
      "namePublicHelp": "Syns på mottagarens inställningssida för prenumerationer.",
      "listTitle": "Titel på prenumerationssidan",
      "listDescription": "Beskriv vad du får när du prenumererar.",
      "descriptionVisible": "Syns publikt på prenumerationssidan.",
      "contactListAddedTitle": "Lista skapad!",
      "contactListAdded": "En lista har lagts till.",
      "buttonCreate": "Skapa lista",
      "buttonCancel": "Avbryt",
    },
    // Source: resources/assets/js/lang/components/copyToTeam/sv.json
    "copyToTeam": {
      "menuCopy": "Kopiera till ett annat team",
      "titleEmail": "Kopiera utskick till ett annat team",
      "titleTemplate": "Kopiera mall till ett annat team",
      "bodyEmail": "Kopian sparas som ett utkast med det valda teamets avsändare, sidfot och varumärkesinställningar. Mottagarna kopieras inte.",
      "bodyTemplate": "Kopian använder det valda teamets varumärkesinställningar.",
      "noteText": "Text i innehållet, till exempel ett företagsnamn, kopieras som den är.",
      "buttonCopy": "Kopiera",
      "buttonCancel": "Avbryt",
      "toastCopied": "Kopierat till :team",
      "toastOpen": "Öppna",
      "toastFailed": "Kunde inte kopiera till :team",
    },
    // Source: resources/assets/js/lang/components/chooseSegment/sv.json
    "chooseSegment": {
      "dialogTitle": "Välj listor",
      "buttonCancel": "Avbryt",
      "segmentAnd": "och",
      "segmentOr": "eller",
      "selectDatatype": "Välj",
      "lastEmail": "Senaste mejl",
      "allContacts": "Alla kontakter",
      "chooseLists": "Välj listor",
      "newSegment": "Nytt filter",
      "nameSegment": "Filternamn",
      "buttonAddsection": "Ny sektion",
      "searchLists": "Sök och välj",
      "noName": "Döp filtret",
      "noFiltersAdded": "Lägg till sektion",
      "sectionLists": "Kontakter i listor",
      "sectionOpened": "Öppnat",
      "sectionNoopen": "Öppnade inte",
      "sectionClicked": "Klickat",
      "sectionNoclick": "Klickade inte",
      "sectionOpenedOrClicked": "Öppnade eller klickade",
      "sectionDidntOpenOrClick": "Öppnade eller klickade inte",
      "selectEmail": "Sök",
      "uniqueContacts": "Unika och ej",
      "suppressedContacts": "undantagna kontakter",
      "menuEdit": "Redigera",
    },
    "charts": {
      // Source: resources/assets/js/lang/components/charts/line/sv.json
      "line": {
        "opens": "Öppnade",
        "clicks": "Klick",
      },
    },
    "billing": {
      // Source: resources/assets/js/lang/components/billing/thank-you/sv.json
      "thank-you": {
        "headline": "Tack för din betalning! 🎉",
      },
    },
    // Source: resources/assets/js/lang/components/appbar/sv.json
    "appbar": {
      "menuSettings": "Team inställningar",
      "menuHelp": "Hjälp & guider",
      "menuHelpurl": "https://www.minutemailer.com/sv/support",
      "feedback": "Skicka oss feedback",
      "feedbackUrl": "mailto:hello@minutemailer.com?subject=Skicka%20oss%20feedback",
      "menuLogout": "Logga ut",
      "createTeam": "Skapa nytt team",
      "privateAccount": "Privat konto",
      "untitled": "Utkast",
      "menuAccount": "Kontoinställningar",
      "menuTeams": "Dina team",
      "menuBilling": "Betalning",
      "menuChatSupport": "Chatt support",
    },
    // Source: resources/assets/js/lang/components/aiImprove/sv.json
    "aiImprove": {
      "labelOriginal": "Originaltext",
      "labelUpdated": "Ändrad text",
      "language": "Välj språk",
      "translate": "Översätt",
      "reject": "Avbryt",
      "regenerate": "Föreslå ny version",
      "approve": "Spara ändring",
    },
    // Source: resources/assets/js/lang/components/ai-loading-screen/sv.json
    "ai-loading-screen": {
      "step1": "Skriver en bra rubrik",
      "step2": "Jobbar på texten",
      "step3": "Ställer in designen",
      "step4": "Fantiserar fram en bild",
    },
    // Source: resources/assets/js/lang/components/accountplan/sv.json
    "accountplan": {
      "checkoutTitle": "Betala för ditt konto",
      "labelMonthly": "/mån",
      "labelYearly": "/år",
      "buttonCurrent": "Nuvarande",
      "buttonDowngrade": "Nedgradera",
      "buttonUpgrade": "Uppgradera",
      "unlimited": "Obegränsat",
      "priority": "Prioriterad",
      "support": "{0} support",
      "billedYearly": "Faktureras årligen",
      "billedMonthly": "Faktureras månadsvis",
      "creditsMonth": "{0} krediter/månad",
      "contacts": "{0} kontakter",
      "aiImprovements": "AI förbättringar ✨",
      "teamMembers": "{0} medlemmar/team",
      "premiumTemplates": "Premium e-postmallar",
      "uploadFiles": "Skicka filer",
      "startHere": "Börja här",
      "freeForever": "Alltid gratis",
      "customAccount": "Betala månadsvis",
      "customBilling": "eller årsvis",
      "premiumOnboarding": "Premium support",
      "uniqueIp": "Egen IP adress",
      "contactUs": "Kontakta oss",
      "premiumContactMessage": "Hej! Jag är intresserad av en custom plan. Kan ni hjälpa mig?",
      "limitedStats": "30 dagars",
      "unlimitedStats": "Obegränsad",
      "statistics": "historik",
    },
  },
} as const;
